var items = {
  "block.minecraft.acacia_button": "Boton Akasia",
  "block.minecraft.acacia_door": "Daras Akasia",
  "block.minecraft.acacia_fence": "Ke Akasia",
  "block.minecraft.acacia_fence_gate": "Yet Ke Akasia",
  "block.minecraft.acacia_hanging_sign": "Arwodh-Gregi Akasia",
  "block.minecraft.acacia_leaves": "Del Akasia",
  "block.minecraft.acacia_log": "Kyf Akasia",
  "block.minecraft.acacia_planks": "Estyl Akasia",
  "block.minecraft.acacia_pressure_plate": "Plat Gwaskedh Akasia",
  "block.minecraft.acacia_sapling": "Akasia Yowynk",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Arwodh Akasia",
  "block.minecraft.acacia_slab": "Leghen Akasia",
  "block.minecraft.acacia_stairs": "Grisyow Akasia",
  "block.minecraft.acacia_trapdoor": "Lo an Jowl Akasia",
  "block.minecraft.acacia_wall_hanging_sign": "Arwodh-Gregi Fos Akasia",
  "block.minecraft.acacia_wall_sign": "Arwodh Fos Akasia",
  "block.minecraft.acacia_wood": "Prenn Akasia",
  "block.minecraft.activator_rail": "Hyns Horn Bewhe",
  "block.minecraft.air": "Ayr",
  "block.minecraft.allium": "Keninen",
  "block.minecraft.amethyst_block": "Stock Amethyst",
  "block.minecraft.amethyst_cluster": "Bush Amethyst",
  "block.minecraft.ancient_debris": "Hen Atal",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Leghen Andesit",
  "block.minecraft.andesite_stairs": "Grisyow Andesit",
  "block.minecraft.andesite_wall": "Fos Andesit",
  "block.minecraft.anvil": "Anwan",
  "block.minecraft.attached_melon_stem": "Garen Bompyon Hweg Stag",
  "block.minecraft.attached_pumpkin_stem": "Garen Bompyon Stag",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Del Azalea",
  "block.minecraft.azure_bluet": "Arlodhesow Krener",
  "block.minecraft.bamboo": "Kors Eynda",
  "block.minecraft.bamboo_block": "Stock Kors Eynda",
  "block.minecraft.bamboo_button": "Boton Kors Eynda",
  "block.minecraft.bamboo_door": "Daras Kors Eynda",
  "block.minecraft.bamboo_fence": "Ke Kors Eynda",
  "block.minecraft.bamboo_fence_gate": "Yet Ke Kors Eynda",
  "block.minecraft.bamboo_hanging_sign": "Arwodh-Gregi Kors Eynda",
  "block.minecraft.bamboo_mosaic": "Brithweyth Kors Eynda",
  "block.minecraft.bamboo_mosaic_slab": "Leghen Vrithweyth Kors Eynda",
  "block.minecraft.bamboo_mosaic_stairs": "Grisyow Brithweyth Kors Eynda",
  "block.minecraft.bamboo_planks": "Estyl Kors Eynda",
  "block.minecraft.bamboo_pressure_plate": "Plat Gwaskedh Kors Eynda",
  "block.minecraft.bamboo_sapling": "Egin Kors Eynda",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Arwodh Kors Eynda",
  "block.minecraft.bamboo_slab": "Leghen Gors Eynda",
  "block.minecraft.bamboo_stairs": "Grisyow Kors Eynda",
  "block.minecraft.bamboo_trapdoor": "Lo an Jowl Kors Eynda",
  "block.minecraft.bamboo_wall_hanging_sign": "Arwodh-Gregi Fos Kors Eynda",
  "block.minecraft.bamboo_wall_sign": "Arwodh Fos Kors Eynda",
  "block.minecraft.banner.base.black": "Keyndir Leun Du",
  "block.minecraft.banner.base.blue": "Keyndir Leun Glas",
  "block.minecraft.banner.base.brown": "Keyndir Leun Gell",
  "block.minecraft.banner.base.cyan": "Keyndir Leun Glaswyrdh",
  "block.minecraft.banner.base.gray": "Keyndir Leun Loos",
  "block.minecraft.banner.base.green": "Keyndir Leun Gwyrdh",
  "block.minecraft.banner.base.light_blue": "Keyndir Leun Glaswynn",
  "block.minecraft.banner.base.light_gray": "Keyndir Leun Gwynnloos",
  "block.minecraft.banner.base.lime": "Keyndir Leun Gwyrdhwynn",
  "block.minecraft.banner.base.magenta": "Keyndir Leun Majenta",
  "block.minecraft.banner.base.orange": "Keyndir Leun Rudhvelyn",
  "block.minecraft.banner.base.pink": "Keyndir Leun Rudhwynn",
  "block.minecraft.banner.base.purple": "Keyndir Leun Purpur",
  "block.minecraft.banner.base.red": "Keyndir Leun Rudh",
  "block.minecraft.banner.base.white": "Keyndir Leun Gwynn",
  "block.minecraft.banner.base.yellow": "Keyndir Leun Melyn",
  "block.minecraft.banner.border.black": "Amal Du",
  "block.minecraft.banner.border.blue": "Amal Glas",
  "block.minecraft.banner.border.brown": "Amal Gell",
  "block.minecraft.banner.border.cyan": "Amal Glaswyrdh",
  "block.minecraft.banner.border.gray": "Amal Loos",
  "block.minecraft.banner.border.green": "Amal Gwyrdh",
  "block.minecraft.banner.border.light_blue": "Amal Glaswynn",
  "block.minecraft.banner.border.light_gray": "Amal Gwynnloos",
  "block.minecraft.banner.border.lime": "Amal Gwyrdhwynn",
  "block.minecraft.banner.border.magenta": "Amal Majenta",
  "block.minecraft.banner.border.orange": "Amal Rudhvelyn",
  "block.minecraft.banner.border.pink": "Amal Rudhwynn",
  "block.minecraft.banner.border.purple": "Amal Purpur",
  "block.minecraft.banner.border.red": "Amal Rudh",
  "block.minecraft.banner.border.white": "Amal Gwynn",
  "block.minecraft.banner.border.yellow": "Amal Melyn",
  "block.minecraft.banner.bricks.black": "Keyndir Bryckys Du",
  "block.minecraft.banner.bricks.blue": "Keyndir Bryckys Glas",
  "block.minecraft.banner.bricks.brown": "Keyndir Bryckys Gell",
  "block.minecraft.banner.bricks.cyan": "Keyndir Bryckys Glaswyrdh",
  "block.minecraft.banner.bricks.gray": "Keyndir Bryckys Loos",
  "block.minecraft.banner.bricks.green": "Keyndir Bryckys Gwyrdh",
  "block.minecraft.banner.bricks.light_blue": "Keyndir Bryckys Glaswynn",
  "block.minecraft.banner.bricks.light_gray": "Keyndir Bryckys Gwynnloos",
  "block.minecraft.banner.bricks.lime": "Keyndir Bryckys Gwyrdhwynn",
  "block.minecraft.banner.bricks.magenta": "Keyndir Bryckys Majenta",
  "block.minecraft.banner.bricks.orange": "Keyndir Bryckys Rudhvelyn",
  "block.minecraft.banner.bricks.pink": "Keyndir Bryckys Rudhwynn",
  "block.minecraft.banner.bricks.purple": "Keyndir Bryckys Purpur",
  "block.minecraft.banner.bricks.red": "Keyndir Bryckys Rudh",
  "block.minecraft.banner.bricks.white": "Keyndir Bryckys Gwynn",
  "block.minecraft.banner.bricks.yellow": "Keyndir Bryckys Melyn",
  "block.minecraft.banner.circle.black": "Kylgh Du",
  "block.minecraft.banner.circle.blue": "Kylgh Glas",
  "block.minecraft.banner.circle.brown": "Kylgh Gell",
  "block.minecraft.banner.circle.cyan": "Kylgh Glaswyrdh",
  "block.minecraft.banner.circle.gray": "Kylgh Loos",
  "block.minecraft.banner.circle.green": "Kylgh Gwyrdh",
  "block.minecraft.banner.circle.light_blue": "Kylgh Glaswynn",
  "block.minecraft.banner.circle.light_gray": "Kylgh Gwynnloos",
  "block.minecraft.banner.circle.lime": "Kylgh Gwyrdhwynn",
  "block.minecraft.banner.circle.magenta": "Kylgh Majenta",
  "block.minecraft.banner.circle.orange": "Kylgh Rudhvelyn",
  "block.minecraft.banner.circle.pink": "Kylgh Rudhwynn",
  "block.minecraft.banner.circle.purple": "Kylgh Purpur",
  "block.minecraft.banner.circle.red": "Kylgh Rudh",
  "block.minecraft.banner.circle.white": "Kylgh Gwynn",
  "block.minecraft.banner.circle.yellow": "Kylgh Melyn",
  "block.minecraft.banner.creeper.black": "Arwodh Kreeper Du",
  "block.minecraft.banner.creeper.blue": "Arwodh Kreeper Glas",
  "block.minecraft.banner.creeper.brown": "Arwodh Kreeper Gell",
  "block.minecraft.banner.creeper.cyan": "Arwodh Kreeper Glaswyrdh",
  "block.minecraft.banner.creeper.gray": "Arwodh Kreeper Loos",
  "block.minecraft.banner.creeper.green": "Arwodh Kreeper Gwyrdh",
  "block.minecraft.banner.creeper.light_blue": "Arwodh Kreeper Glaswynn",
  "block.minecraft.banner.creeper.light_gray": "Arwodh Kreeper Gwynnloos",
  "block.minecraft.banner.creeper.lime": "Arwodh Kreeper Gwyrdhwynn",
  "block.minecraft.banner.creeper.magenta": "Arwodh Kreeper Majenta",
  "block.minecraft.banner.creeper.orange": "Arwodh Kreeper Rudhvelyn",
  "block.minecraft.banner.creeper.pink": "Arwodh Kreeper Rudhwynn",
  "block.minecraft.banner.creeper.purple": "Arwodh Kreeper Purpur",
  "block.minecraft.banner.creeper.red": "Arwodh Kreeper Rudh",
  "block.minecraft.banner.creeper.white": "Arwodh Kreeper Gwynn",
  "block.minecraft.banner.creeper.yellow": "Arwodh Kreeper Melyn",
  "block.minecraft.banner.cross.black": "Gwarthol Dhu",
  "block.minecraft.banner.cross.blue": "Gwarthol Las",
  "block.minecraft.banner.cross.brown": "Gwarthol Ell",
  "block.minecraft.banner.cross.cyan": "Gwarthol Laswyrdh",
  "block.minecraft.banner.cross.gray": "Gwarthol Loos",
  "block.minecraft.banner.cross.green": "Gwarthol Wyrdh",
  "block.minecraft.banner.cross.light_blue": "Gwarthol Laswynn",
  "block.minecraft.banner.cross.light_gray": "Gwarthol Wynnloos",
  "block.minecraft.banner.cross.lime": "Gwarthol Wyrdhwynn",
  "block.minecraft.banner.cross.magenta": "Gwarthol Vajenta",
  "block.minecraft.banner.cross.orange": "Gwarthol Rudhvelyn",
  "block.minecraft.banner.cross.pink": "Gwarthol Rudhwynn",
  "block.minecraft.banner.cross.purple": "Gwarthol Burpur",
  "block.minecraft.banner.cross.red": "Gwarthol Rudh",
  "block.minecraft.banner.cross.white": "Gwarthol Wynn",
  "block.minecraft.banner.cross.yellow": "Gwarthol Velyn",
  "block.minecraft.banner.curly_border.black": "Amal Du Kribys",
  "block.minecraft.banner.curly_border.blue": "Amal Glas Kribys",
  "block.minecraft.banner.curly_border.brown": "Amal Gell Kribys",
  "block.minecraft.banner.curly_border.cyan": "Amal Glaswyrdh Kribys",
  "block.minecraft.banner.curly_border.gray": "Amal Loos Kribys",
  "block.minecraft.banner.curly_border.green": "Amal Gwyrdh Kribys",
  "block.minecraft.banner.curly_border.light_blue": "Amal Glaswyrdh Kribys",
  "block.minecraft.banner.curly_border.light_gray": "Amal Gwynnloos Kribys",
  "block.minecraft.banner.curly_border.lime": "Amal Gwyrdhwynn Kribys",
  "block.minecraft.banner.curly_border.magenta": "Amal Majenta Kribys",
  "block.minecraft.banner.curly_border.orange": "Amal Rudhvelyn Kribys",
  "block.minecraft.banner.curly_border.pink": "Amal Rudhwynn Kribys",
  "block.minecraft.banner.curly_border.purple": "Amal Purpur Kribys",
  "block.minecraft.banner.curly_border.red": "Amal Rudh Kribys",
  "block.minecraft.banner.curly_border.white": "Amal Gwynn Kribys",
  "block.minecraft.banner.curly_border.yellow": "Amal Melyn Kribys",
  "block.minecraft.banner.diagonal_left.black": "Per Bond Du Kledh",
  "block.minecraft.banner.diagonal_left.blue": "Per Bond Glas Kledh",
  "block.minecraft.banner.diagonal_left.brown": "Per Bond Gell Kledh",
  "block.minecraft.banner.diagonal_left.cyan": "Per Bond Glaswyrdh Kledh",
  "block.minecraft.banner.diagonal_left.gray": "Per Bond Loos Kledh",
  "block.minecraft.banner.diagonal_left.green": "Per Bond Gwyrdh Kledh",
  "block.minecraft.banner.diagonal_left.light_blue": "Per Bond Glaswynn Kledh",
  "block.minecraft.banner.diagonal_left.light_gray": "Per Bond Gwynnloos Kledh",
  "block.minecraft.banner.diagonal_left.lime": "Per Bond Gwyrdhwynn Kledh",
  "block.minecraft.banner.diagonal_left.magenta": "Per Bond Majenta Kledh",
  "block.minecraft.banner.diagonal_left.orange": "Per Bond Rudhvelyn Kledh",
  "block.minecraft.banner.diagonal_left.pink": "Per Bond Rudhwynn Kledh",
  "block.minecraft.banner.diagonal_left.purple": "Per Bond Purpur Kledh",
  "block.minecraft.banner.diagonal_left.red": "Per Bond Rudh Kledh",
  "block.minecraft.banner.diagonal_left.white": "Per Bond Gwynn Kledh",
  "block.minecraft.banner.diagonal_left.yellow": "Per Bond Melyn Kledh",
  "block.minecraft.banner.diagonal_right.black": "Per Bond Du",
  "block.minecraft.banner.diagonal_right.blue": "Per Bond Glas",
  "block.minecraft.banner.diagonal_right.brown": "Per Bond Gell",
  "block.minecraft.banner.diagonal_right.cyan": "Per Bond Glaswyrdh",
  "block.minecraft.banner.diagonal_right.gray": "Per Bond Loos",
  "block.minecraft.banner.diagonal_right.green": "Per Bond Gwyrdh",
  "block.minecraft.banner.diagonal_right.light_blue": "Per Bond Glaswynn",
  "block.minecraft.banner.diagonal_right.light_gray": "Per Bond Gwynnloos",
  "block.minecraft.banner.diagonal_right.lime": "Per Bond Gwyrdhwynn",
  "block.minecraft.banner.diagonal_right.magenta": "Per Bond Majenta",
  "block.minecraft.banner.diagonal_right.orange": "Per Bond Rudhvelyn",
  "block.minecraft.banner.diagonal_right.pink": "Per Bond Rudhwynn",
  "block.minecraft.banner.diagonal_right.purple": "Per Bond Purpur",
  "block.minecraft.banner.diagonal_right.red": "Per Bond Rudh",
  "block.minecraft.banner.diagonal_right.white": "Per Bond Gwynn",
  "block.minecraft.banner.diagonal_right.yellow": "Per Bond Melyn",
  "block.minecraft.banner.diagonal_up_left.black": "Per Bond Du Kildennys",
  "block.minecraft.banner.diagonal_up_left.blue": "Per Bond Glas Kildennys",
  "block.minecraft.banner.diagonal_up_left.brown": "Per Bond Gell Kildennys",
  "block.minecraft.banner.diagonal_up_left.cyan": "Per Bond Glaswyrdh Kildennys",
  "block.minecraft.banner.diagonal_up_left.gray": "Per Bond Loos Kildennys",
  "block.minecraft.banner.diagonal_up_left.green": "Per Bond Gwyrdh Kildennys",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Per Bond Glaswynn Kildennys",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Per Bond Gwynnloos Kildennys",
  "block.minecraft.banner.diagonal_up_left.lime": "Per Bond Gwyrdhwynn Kildennys",
  "block.minecraft.banner.diagonal_up_left.magenta": "Per Bond Majenta Kildennys",
  "block.minecraft.banner.diagonal_up_left.orange": "Per Bond Rudhvelyn Kildennys",
  "block.minecraft.banner.diagonal_up_left.pink": "Per Bond Rudhwynn Kildennys",
  "block.minecraft.banner.diagonal_up_left.purple": "Per Bond Purpur Kildennys",
  "block.minecraft.banner.diagonal_up_left.red": "Per Bond Rudh Kildennys",
  "block.minecraft.banner.diagonal_up_left.white": "Per Bond Gwynn Kildennys",
  "block.minecraft.banner.diagonal_up_left.yellow": "Per Bond Melyn Kildennys",
  "block.minecraft.banner.diagonal_up_right.black": "Per Bond Du Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.blue": "Per Bond Glas Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.brown": "Per Bond Gell Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.cyan": "Per Bond Glaswyrdh Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.gray": "Per Bond Loos Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.green": "Per Bond Gwyrdh Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Per Bond Glaswynn Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Per Bond Gwynnloos Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.lime": "Per Bond Gwyrdhwynn Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.magenta": "Per Bond Majenta Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.orange": "Per Bond Rudhvelyn Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.pink": "Per Bond Rudhwynn Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.purple": "Per Bond Purpur Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.red": "Per Bond Rudh Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.white": "Per Bond Gwynn Kledh Kildennys",
  "block.minecraft.banner.diagonal_up_right.yellow": "Per Bond Melyn Kledh Kildennys",
  "block.minecraft.banner.flow.black": "Fros Du",
  "block.minecraft.banner.flow.blue": "Fros Glas",
  "block.minecraft.banner.flow.brown": "Fros Gell",
  "block.minecraft.banner.flow.cyan": "Fros Glaswyrdh",
  "block.minecraft.banner.flow.gray": "Fros Loos",
  "block.minecraft.banner.flow.green": "Fros Gwyrdh",
  "block.minecraft.banner.flow.light_blue": "Fros Glaswynn",
  "block.minecraft.banner.flow.light_gray": "Fros Gwynnloos",
  "block.minecraft.banner.flow.lime": "Fros Gwyrdhwynn",
  "block.minecraft.banner.flow.magenta": "Fros Majenta",
  "block.minecraft.banner.flow.orange": "Fros Rudhvelyn",
  "block.minecraft.banner.flow.pink": "Fros Rudhwynn",
  "block.minecraft.banner.flow.purple": "Fros Purpur",
  "block.minecraft.banner.flow.red": "Fros Rudh",
  "block.minecraft.banner.flow.white": "Fros Gwynn",
  "block.minecraft.banner.flow.yellow": "Fros Melyn",
  "block.minecraft.banner.flower.black": "Arwodh Bleujen Dhu",
  "block.minecraft.banner.flower.blue": "Arwodh Bleujen Las",
  "block.minecraft.banner.flower.brown": "Arwodh Bleujen Ell",
  "block.minecraft.banner.flower.cyan": "Arwodh Bleujen Laswyrdh",
  "block.minecraft.banner.flower.gray": "Arwodh Bleujen Loos",
  "block.minecraft.banner.flower.green": "Arwodh Bleujen Wyrdh",
  "block.minecraft.banner.flower.light_blue": "Arwodh Bleujen Laswynn",
  "block.minecraft.banner.flower.light_gray": "Arwodh Bleujen Wynnloos",
  "block.minecraft.banner.flower.lime": "Arwodh Bleujen Wyrdhwynn",
  "block.minecraft.banner.flower.magenta": "Arwodh Bleujen Vajenta",
  "block.minecraft.banner.flower.orange": "Arwodh Bleujen Rudhvelyn",
  "block.minecraft.banner.flower.pink": "Arwodh Bleujen Rudhwynn",
  "block.minecraft.banner.flower.purple": "Arwodh Bleujen Burpur",
  "block.minecraft.banner.flower.red": "Arwodh Bleujen Rudh",
  "block.minecraft.banner.flower.white": "Arwodh Bleujen Wynn",
  "block.minecraft.banner.flower.yellow": "Arwodh Bleujen Velyn",
  "block.minecraft.banner.globe.black": "Pel an Norvys Dhu",
  "block.minecraft.banner.globe.blue": "Pel an Norvys Las",
  "block.minecraft.banner.globe.brown": "Pel an Norvys Ell",
  "block.minecraft.banner.globe.cyan": "Pel an Norvys Laswyrdh",
  "block.minecraft.banner.globe.gray": "Pel an Norvys Loos",
  "block.minecraft.banner.globe.green": "Pel an Norvys Wyrdh",
  "block.minecraft.banner.globe.light_blue": "Pel an Norvys Laswynn",
  "block.minecraft.banner.globe.light_gray": "Pel an Norvys Wynnloos",
  "block.minecraft.banner.globe.lime": "Pel an Norvys Wyrdhwynn",
  "block.minecraft.banner.globe.magenta": "Pel an Norvys Vajenta",
  "block.minecraft.banner.globe.orange": "Pel an Norvys Rudhvelyn",
  "block.minecraft.banner.globe.pink": "Pel an Norvys Rudhwynn",
  "block.minecraft.banner.globe.purple": "Pel an Norvys Burpur",
  "block.minecraft.banner.globe.red": "Pel an Norvys Rudh",
  "block.minecraft.banner.globe.white": "Pel an Norvys Wynn",
  "block.minecraft.banner.globe.yellow": "Pel an Norvys Velyn",
  "block.minecraft.banner.gradient.black": "Ledras Du",
  "block.minecraft.banner.gradient.blue": "Ledras Glas",
  "block.minecraft.banner.gradient.brown": "Ledras Gell",
  "block.minecraft.banner.gradient.cyan": "Ledras Glaswyrdh",
  "block.minecraft.banner.gradient.gray": "Ledras Loos",
  "block.minecraft.banner.gradient.green": "Ledras Gwyrdh",
  "block.minecraft.banner.gradient.light_blue": "Ledras Glaswynn",
  "block.minecraft.banner.gradient.light_gray": "Ledras Gwynnloos",
  "block.minecraft.banner.gradient.lime": "Ledras Gwynnwyrdh",
  "block.minecraft.banner.gradient.magenta": "Ledras Majenta",
  "block.minecraft.banner.gradient.orange": "Ledras Rudhvelyn",
  "block.minecraft.banner.gradient.pink": "Ledras Rudhwynn",
  "block.minecraft.banner.gradient.purple": "Ledras Purpur",
  "block.minecraft.banner.gradient.red": "Ledras Rudh",
  "block.minecraft.banner.gradient.white": "Ledras Gwynn",
  "block.minecraft.banner.gradient.yellow": "Ledras Melyn",
  "block.minecraft.banner.gradient_up.black": "Ledras Du Kildennys",
  "block.minecraft.banner.gradient_up.blue": "Ledras Glas Kildennys",
  "block.minecraft.banner.gradient_up.brown": "Ledras Gell Kildennys",
  "block.minecraft.banner.gradient_up.cyan": "Ledras Glaswrydh Kildennys",
  "block.minecraft.banner.gradient_up.gray": "Ledras Loos Kildennys",
  "block.minecraft.banner.gradient_up.green": "Ledras Gwyrdh Kildennys",
  "block.minecraft.banner.gradient_up.light_blue": "Ledras Glaswynn Kildennys",
  "block.minecraft.banner.gradient_up.light_gray": "Ledras Gwynnloos Kildennys",
  "block.minecraft.banner.gradient_up.lime": "Ledras Gwyrdhwynn Kildennys",
  "block.minecraft.banner.gradient_up.magenta": "Ledras Majenta Kildennys",
  "block.minecraft.banner.gradient_up.orange": "Ledras Rudhvelyn Kildennys",
  "block.minecraft.banner.gradient_up.pink": "Ledras Rudhwynn Kildennys",
  "block.minecraft.banner.gradient_up.purple": "Ledras Purpur Kildennys",
  "block.minecraft.banner.gradient_up.red": "Ledras Rudh Kildennys",
  "block.minecraft.banner.gradient_up.white": "Ledras Gwynn Kildennys",
  "block.minecraft.banner.gradient_up.yellow": "Ledras Melyn Kildennys",
  "block.minecraft.banner.guster.black": "Hwaff Du",
  "block.minecraft.banner.guster.blue": "Awel Glor Glas",
  "block.minecraft.banner.guster.brown": "Awel Glor Gell",
  "block.minecraft.banner.guster.cyan": "Awel Glor Glaswyrdh",
  "block.minecraft.banner.guster.gray": "Awel Glor Loos",
  "block.minecraft.banner.guster.green": "Awel Glor Gwyrdh",
  "block.minecraft.banner.guster.light_blue": "Awel Glor Glaswynn",
  "block.minecraft.banner.guster.light_gray": "Awel Glor Gwynnloos",
  "block.minecraft.banner.guster.lime": "Awel Glor Gwyrdhwynn",
  "block.minecraft.banner.guster.magenta": "Awel Glor Majenta",
  "block.minecraft.banner.guster.orange": "Awel Glor Rudhvelyn",
  "block.minecraft.banner.guster.pink": "Awel Glor Rudhwynn",
  "block.minecraft.banner.guster.purple": "Awel Glor Purpur",
  "block.minecraft.banner.guster.red": "Awel Glor Rudh",
  "block.minecraft.banner.guster.white": "Awel Glor Gwynn",
  "block.minecraft.banner.guster.yellow": "Awel Glor Melyn",
  "block.minecraft.banner.half_horizontal.black": "Per Fess Du",
  "block.minecraft.banner.half_horizontal.blue": "Per Fess Glas",
  "block.minecraft.banner.half_horizontal.brown": "Per Fess Gell",
  "block.minecraft.banner.half_horizontal.cyan": "Per Fess Glaswyrdh",
  "block.minecraft.banner.half_horizontal.gray": "Per Fess Loos",
  "block.minecraft.banner.half_horizontal.green": "Per Fess Gwyrdh",
  "block.minecraft.banner.half_horizontal.light_blue": "Per Fess Glaswynn",
  "block.minecraft.banner.half_horizontal.light_gray": "Per Fess Gwynnloos",
  "block.minecraft.banner.half_horizontal.lime": "Per Fess Gwyrdhwynn",
  "block.minecraft.banner.half_horizontal.magenta": "Per Fess Majenta",
  "block.minecraft.banner.half_horizontal.orange": "Per Fess Rudhvelyn",
  "block.minecraft.banner.half_horizontal.pink": "Per Fess Rudhwynn",
  "block.minecraft.banner.half_horizontal.purple": "Per Fess Purpur",
  "block.minecraft.banner.half_horizontal.red": "Per Fess Rudh",
  "block.minecraft.banner.half_horizontal.white": "Per Fess Gwyn",
  "block.minecraft.banner.half_horizontal.yellow": "Per Fess Melyn",
  "block.minecraft.banner.half_horizontal_bottom.black": "Per Fess Du Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Per Fess Glas Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Per Fess Gell Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Per Fess Glaswyrdh Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Per Fess Loos Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.green": "Per Fess Gwyrdh Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Per Fess Glaswynn Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Per Fess Gwynnloos Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Per Fess Gwyrdhwynn Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Per Fess Majenta Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Per Fess Rudhvelyn Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Per Fess Rudhwynn Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Per Fess Purpur Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.red": "Per Fess Rudh Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.white": "Per Fess Gwynn Kildennys",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Per Fess Melyn Kildennys",
  "block.minecraft.banner.half_vertical.black": "Per Peul Du",
  "block.minecraft.banner.half_vertical.blue": "Per Peul Glas",
  "block.minecraft.banner.half_vertical.brown": "Per Peul Gell",
  "block.minecraft.banner.half_vertical.cyan": "Per Peul Glaswyrdh",
  "block.minecraft.banner.half_vertical.gray": "Per Peul Loos",
  "block.minecraft.banner.half_vertical.green": "Per Peul Gwyrdh",
  "block.minecraft.banner.half_vertical.light_blue": "Per Peul Glaswynn",
  "block.minecraft.banner.half_vertical.light_gray": "Per Peul Gwynnloos",
  "block.minecraft.banner.half_vertical.lime": "Per Peul Gwyrdhwynn",
  "block.minecraft.banner.half_vertical.magenta": "Per Peul Majenta",
  "block.minecraft.banner.half_vertical.orange": "Per Peul Rudhvelyn",
  "block.minecraft.banner.half_vertical.pink": "Per Peul Rudhwynn",
  "block.minecraft.banner.half_vertical.purple": "Per Peul Purpur",
  "block.minecraft.banner.half_vertical.red": "Per Peul Rudh",
  "block.minecraft.banner.half_vertical.white": "Per Peul Gwynn",
  "block.minecraft.banner.half_vertical.yellow": "Per Peul Melyn",
  "block.minecraft.banner.half_vertical_right.black": "Per Peul Du Kildennys",
  "block.minecraft.banner.half_vertical_right.blue": "Per Peul Glas Kildennys",
  "block.minecraft.banner.half_vertical_right.brown": "Per Peul Gell Kildennys",
  "block.minecraft.banner.half_vertical_right.cyan": "Per Peul Glaswyrdh Kildennys",
  "block.minecraft.banner.half_vertical_right.gray": "Per Peul Loos Kildennys",
  "block.minecraft.banner.half_vertical_right.green": "Per Peul Gwyrdh Kildennys",
  "block.minecraft.banner.half_vertical_right.light_blue": "Per Peul Glaswynn Kildennys",
  "block.minecraft.banner.half_vertical_right.light_gray": "Per Peul Gwynnloos Kildennys",
  "block.minecraft.banner.half_vertical_right.lime": "Per Peul Gwyrdhwynn Kildennys",
  "block.minecraft.banner.half_vertical_right.magenta": "Per Peul Majenta Kildennys",
  "block.minecraft.banner.half_vertical_right.orange": "Per Peul Rudhvelyn Kildennys",
  "block.minecraft.banner.half_vertical_right.pink": "Per Peul Rudhwynn Kildennys",
  "block.minecraft.banner.half_vertical_right.purple": "Per Peul Purpur Kildennys",
  "block.minecraft.banner.half_vertical_right.red": "Per Peul Rudh Kildennys",
  "block.minecraft.banner.half_vertical_right.white": "Per Peul Gwynn Kildennys",
  "block.minecraft.banner.half_vertical_right.yellow": "Per Peul Melyn Kildennys",
  "block.minecraft.banner.mojang.black": "Pyth Du",
  "block.minecraft.banner.mojang.blue": "Pyth Glas",
  "block.minecraft.banner.mojang.brown": "Pyth Gell",
  "block.minecraft.banner.mojang.cyan": "Pyth Glaswyrdh",
  "block.minecraft.banner.mojang.gray": "Pyth Loos",
  "block.minecraft.banner.mojang.green": "Pyth Gwyrdh",
  "block.minecraft.banner.mojang.light_blue": "Pyth Glaswynn",
  "block.minecraft.banner.mojang.light_gray": "Pyth Gwynnloos",
  "block.minecraft.banner.mojang.lime": "Pyth Gwyrdhwynn",
  "block.minecraft.banner.mojang.magenta": "Pyth Majenta",
  "block.minecraft.banner.mojang.orange": "Pyth Rudhvelyn",
  "block.minecraft.banner.mojang.pink": "Pyth Rudhwynn",
  "block.minecraft.banner.mojang.purple": "Pyth Purpur",
  "block.minecraft.banner.mojang.red": "Pyth Rudh",
  "block.minecraft.banner.mojang.white": "Pyth Gwynn",
  "block.minecraft.banner.mojang.yellow": "Pyth Melyn",
  "block.minecraft.banner.piglin.black": "Tron Du",
  "block.minecraft.banner.piglin.blue": "Tron Glas",
  "block.minecraft.banner.piglin.brown": "Tron Gell",
  "block.minecraft.banner.piglin.cyan": "Tron Glaswyrdh",
  "block.minecraft.banner.piglin.gray": "Tron Loos",
  "block.minecraft.banner.piglin.green": "Tron Gwyrdh",
  "block.minecraft.banner.piglin.light_blue": "Tron Glaswynn",
  "block.minecraft.banner.piglin.light_gray": "Tron Gwynnloos",
  "block.minecraft.banner.piglin.lime": "Tron Gwynnwyrdh",
  "block.minecraft.banner.piglin.magenta": "Tron Majenta",
  "block.minecraft.banner.piglin.orange": "Tron Rudhvelyn",
  "block.minecraft.banner.piglin.pink": "Tron Rudhwynn",
  "block.minecraft.banner.piglin.purple": "Tron Purpur",
  "block.minecraft.banner.piglin.red": "Tron Rudh",
  "block.minecraft.banner.piglin.white": "Tron Gwynn",
  "block.minecraft.banner.piglin.yellow": "Tron Melyn",
  "block.minecraft.banner.rhombus.black": "Adamant Du",
  "block.minecraft.banner.rhombus.blue": "Adamant Glas",
  "block.minecraft.banner.rhombus.brown": "Adamant Gell",
  "block.minecraft.banner.rhombus.cyan": "Adamant Glaswyrdh",
  "block.minecraft.banner.rhombus.gray": "Adamant Loos",
  "block.minecraft.banner.rhombus.green": "Adamant Gwyrdh",
  "block.minecraft.banner.rhombus.light_blue": "Adamant Glaswynn",
  "block.minecraft.banner.rhombus.light_gray": "Adamant Gwynnloos",
  "block.minecraft.banner.rhombus.lime": "Adamant Gwyrdhwynn",
  "block.minecraft.banner.rhombus.magenta": "Adamant Majenta",
  "block.minecraft.banner.rhombus.orange": "Adamant Rudhvelyn",
  "block.minecraft.banner.rhombus.pink": "Adamant Rudhwynn",
  "block.minecraft.banner.rhombus.purple": "Adamant Purpur",
  "block.minecraft.banner.rhombus.red": "Adamant Rudh",
  "block.minecraft.banner.rhombus.white": "Adamant Gwynn",
  "block.minecraft.banner.rhombus.yellow": "Adamant Melyn",
  "block.minecraft.banner.skull.black": "Arwodh Klopen Du",
  "block.minecraft.banner.skull.blue": "Arwodh Klopen Glas",
  "block.minecraft.banner.skull.brown": "Arwodh Klopen Gell",
  "block.minecraft.banner.skull.cyan": "Arwodh Klopen Glaswyrdh",
  "block.minecraft.banner.skull.gray": "Arwodh Klopen Loos",
  "block.minecraft.banner.skull.green": "Arwodh Klopen Gwyrdh",
  "block.minecraft.banner.skull.light_blue": "Arwodh Klopen Glaswynn",
  "block.minecraft.banner.skull.light_gray": "Arwodh Klopen Gwynnloos",
  "block.minecraft.banner.skull.lime": "Arwodh Klopen Gwyrdhwynn",
  "block.minecraft.banner.skull.magenta": "Arwodh Klopen Majenta",
  "block.minecraft.banner.skull.orange": "Arwodh Klopen Rudhvelyn",
  "block.minecraft.banner.skull.pink": "Arwodh Klopen Rudhwynn",
  "block.minecraft.banner.skull.purple": "Arwodh Klopen Purpur",
  "block.minecraft.banner.skull.red": "Arwodh Klopen Rudh",
  "block.minecraft.banner.skull.white": "Arwodh Klopen Gwynn",
  "block.minecraft.banner.skull.yellow": "Arwodh Klopen Melyn",
  "block.minecraft.banner.small_stripes.black": "Peulek Du",
  "block.minecraft.banner.small_stripes.blue": "Peulek Glas",
  "block.minecraft.banner.small_stripes.brown": "Peulek Gell",
  "block.minecraft.banner.small_stripes.cyan": "Peulek Glaswyrdh",
  "block.minecraft.banner.small_stripes.gray": "Peulek Loos",
  "block.minecraft.banner.small_stripes.green": "Peulek Gwyrdh",
  "block.minecraft.banner.small_stripes.light_blue": "Peulek Glaswynn",
  "block.minecraft.banner.small_stripes.light_gray": "Peulek Gwynnloos",
  "block.minecraft.banner.small_stripes.lime": "Peulek Gwyrdhwynn",
  "block.minecraft.banner.small_stripes.magenta": "Peulek Majenta",
  "block.minecraft.banner.small_stripes.orange": "Peulek Rudhvelyn",
  "block.minecraft.banner.small_stripes.pink": "Peulek Rudhwynn",
  "block.minecraft.banner.small_stripes.purple": "Peulek Purpur",
  "block.minecraft.banner.small_stripes.red": "Peulek Rudh",
  "block.minecraft.banner.small_stripes.white": "Peulek Gwynn",
  "block.minecraft.banner.small_stripes.yellow": "Peulek Melyn",
  "block.minecraft.banner.square_bottom_left.black": "Goles Du Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.blue": "Goles Glas Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.brown": "Goles Gell Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.cyan": "Goles Glaswyrdh Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.gray": "Goles Loos Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.green": "Goles Gwyrdh Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.light_blue": "Goles Glaswynn Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.light_gray": "Goles Gwynnloos Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.lime": "Goles Gwyrdhwynn Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.magenta": "Goles Majenta Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.orange": "Goles Rudhvelyn Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.pink": "Goles Rudhwynn Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.purple": "Goles Purpur Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.red": "Goles Rudh Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.white": "Goles Gwynn Kanton Dyghow",
  "block.minecraft.banner.square_bottom_left.yellow": "Goles Melyn Kanton Dyghow",
  "block.minecraft.banner.square_bottom_right.black": "Goles Du Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.blue": "Goles Glas Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.brown": "Goles Gell Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.cyan": "Goles Glaswyrdh Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.gray": "Goles Loos Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.green": "Goles Gwyrdh Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.light_blue": "Goles Glaswynn Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.light_gray": "Goles Gwynnloos Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.lime": "Goles Gwyrdhwynn Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.magenta": "Goles Majenta Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.orange": "Goles Rudhvelyn Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.pink": "Goles Rudhwynn Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.purple": "Goles Purpur Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.red": "Goles Rudh Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.white": "Goles Gwynn Kanton Kledh",
  "block.minecraft.banner.square_bottom_right.yellow": "Goles Melyn Kanton Kledh",
  "block.minecraft.banner.square_top_left.black": "Chyf Du Kanton Dyghow",
  "block.minecraft.banner.square_top_left.blue": "Chyf Glas Kanton Dyghow",
  "block.minecraft.banner.square_top_left.brown": "Chyf Gell Kanton Dyghow",
  "block.minecraft.banner.square_top_left.cyan": "Chyf Glaswyrdh Kanton Dyghow",
  "block.minecraft.banner.square_top_left.gray": "Chyf Loos Kanton Dyghow",
  "block.minecraft.banner.square_top_left.green": "Chyf Gwyrdh Kanton Dyghow",
  "block.minecraft.banner.square_top_left.light_blue": "Chyf Glaswynn Kanton Dyghow",
  "block.minecraft.banner.square_top_left.light_gray": "Chyf Gwynnloos Kanton Dyghow",
  "block.minecraft.banner.square_top_left.lime": "Chyf Gwynnwyrdh Kanton Dyghow",
  "block.minecraft.banner.square_top_left.magenta": "Chyf Majenta Kanton Dyghow",
  "block.minecraft.banner.square_top_left.orange": "Chyf Rudhvelyn Kanton Dyghow",
  "block.minecraft.banner.square_top_left.pink": "Chyf Rudhwynn Kanton Dyghow",
  "block.minecraft.banner.square_top_left.purple": "Chyf Purpur Kanton Dyghow",
  "block.minecraft.banner.square_top_left.red": "Chyf Rudh Kanton Dyghow",
  "block.minecraft.banner.square_top_left.white": "Chyf Gwynn Kanton Dyghow",
  "block.minecraft.banner.square_top_left.yellow": "Chyf Melyn Kanton Dyghow",
  "block.minecraft.banner.square_top_right.black": "Chyf Du Kanton Kledh",
  "block.minecraft.banner.square_top_right.blue": "Chyf Glas Kanton Kledh",
  "block.minecraft.banner.square_top_right.brown": "Chyf Gell Kanton Kledh",
  "block.minecraft.banner.square_top_right.cyan": "Chyf Glaswyrdh Kanton Kledh",
  "block.minecraft.banner.square_top_right.gray": "Chyf Loos Kanton Kledh",
  "block.minecraft.banner.square_top_right.green": "Chyf Gwyrdh Kanton Kledh",
  "block.minecraft.banner.square_top_right.light_blue": "Chyf Glaswynn Kanton Kledh",
  "block.minecraft.banner.square_top_right.light_gray": "Chyf Gwynnloos Kanton Kledh",
  "block.minecraft.banner.square_top_right.lime": "Chyf Gwyrdhwynn Kanton Kledh",
  "block.minecraft.banner.square_top_right.magenta": "Chyf Majenta Kanton Kledh",
  "block.minecraft.banner.square_top_right.orange": "Chyf Rudhvelyn Kanton Kledh",
  "block.minecraft.banner.square_top_right.pink": "Chyf Rudhwynn Kanton Kledh",
  "block.minecraft.banner.square_top_right.purple": "Chyf Purpur Kanton Kledh",
  "block.minecraft.banner.square_top_right.red": "Chyf Rudh Kanton Kledh",
  "block.minecraft.banner.square_top_right.white": "Chyf Gwynn Kanton Kledh",
  "block.minecraft.banner.square_top_right.yellow": "Chyf Melyn Kanton Kledh",
  "block.minecraft.banner.straight_cross.black": "Krows Du",
  "block.minecraft.banner.straight_cross.blue": "Krows Glas",
  "block.minecraft.banner.straight_cross.brown": "Krows Gell",
  "block.minecraft.banner.straight_cross.cyan": "Krows Glaswyrdh",
  "block.minecraft.banner.straight_cross.gray": "Krows Loos",
  "block.minecraft.banner.straight_cross.green": "Krows Gwyrdh",
  "block.minecraft.banner.straight_cross.light_blue": "Krows Glaswynn",
  "block.minecraft.banner.straight_cross.light_gray": "Krows Gwynnloos",
  "block.minecraft.banner.straight_cross.lime": "Krows Limaval",
  "block.minecraft.banner.straight_cross.magenta": "Krows Majenta",
  "block.minecraft.banner.straight_cross.orange": "Krows Rudhvelyn",
  "block.minecraft.banner.straight_cross.pink": "Krows Rudhwynn",
  "block.minecraft.banner.straight_cross.purple": "Krows Purpur",
  "block.minecraft.banner.straight_cross.red": "Krows Rudh",
  "block.minecraft.banner.straight_cross.white": "Krows Gwynn",
  "block.minecraft.banner.straight_cross.yellow": "Krows Meyln",
  "block.minecraft.banner.stripe_bottom.black": "Goles Du",
  "block.minecraft.banner.stripe_bottom.blue": "Goles Glas",
  "block.minecraft.banner.stripe_bottom.brown": "Goles Gell",
  "block.minecraft.banner.stripe_bottom.cyan": "Goles Glaswyrdh",
  "block.minecraft.banner.stripe_bottom.gray": "Goles Loos",
  "block.minecraft.banner.stripe_bottom.green": "Goles Gwyrdh",
  "block.minecraft.banner.stripe_bottom.light_blue": "Goles Glaswynn",
  "block.minecraft.banner.stripe_bottom.light_gray": "Goles Gwynnloos",
  "block.minecraft.banner.stripe_bottom.lime": "Goles Gwyrdhwynn",
  "block.minecraft.banner.stripe_bottom.magenta": "Goles Majenta",
  "block.minecraft.banner.stripe_bottom.orange": "Goles Rudhvelyn",
  "block.minecraft.banner.stripe_bottom.pink": "Goles Rudhwynn",
  "block.minecraft.banner.stripe_bottom.purple": "Goles Purpur",
  "block.minecraft.banner.stripe_bottom.red": "Goles Rudh",
  "block.minecraft.banner.stripe_bottom.white": "Goles Gwynn",
  "block.minecraft.banner.stripe_bottom.yellow": "Goles Melyn",
  "block.minecraft.banner.stripe_center.black": "Peul Du",
  "block.minecraft.banner.stripe_center.blue": "Peul Glas",
  "block.minecraft.banner.stripe_center.brown": "Peul Gell",
  "block.minecraft.banner.stripe_center.cyan": "Peul Glaswyrdh",
  "block.minecraft.banner.stripe_center.gray": "Peul Loos",
  "block.minecraft.banner.stripe_center.green": "Peul Gwyrdh",
  "block.minecraft.banner.stripe_center.light_blue": "Peul Glaswynn",
  "block.minecraft.banner.stripe_center.light_gray": "Peul Gwynnloos",
  "block.minecraft.banner.stripe_center.lime": "Peul Gwyrdhwynn",
  "block.minecraft.banner.stripe_center.magenta": "Peul Majenta",
  "block.minecraft.banner.stripe_center.orange": "Peul Rudhvelyn",
  "block.minecraft.banner.stripe_center.pink": "Peul Rudhwynn",
  "block.minecraft.banner.stripe_center.purple": "Peul Purpur",
  "block.minecraft.banner.stripe_center.red": "Peul Rudh",
  "block.minecraft.banner.stripe_center.white": "Peul Gwynn",
  "block.minecraft.banner.stripe_center.yellow": "Peul Melyn",
  "block.minecraft.banner.stripe_downleft.black": "Bond Du Kledh",
  "block.minecraft.banner.stripe_downleft.blue": "Bond Glas Kledh",
  "block.minecraft.banner.stripe_downleft.brown": "Bond Gell Kledh",
  "block.minecraft.banner.stripe_downleft.cyan": "Bond Glaswyrdh Kledh",
  "block.minecraft.banner.stripe_downleft.gray": "Bond Loos Kledh",
  "block.minecraft.banner.stripe_downleft.green": "Bond Gwyrdh Kledh",
  "block.minecraft.banner.stripe_downleft.light_blue": "Bond Glaswynn Kledh",
  "block.minecraft.banner.stripe_downleft.light_gray": "Bond Gwynnloos Kledh",
  "block.minecraft.banner.stripe_downleft.lime": "Bond Gwyrdhwynn Kledh",
  "block.minecraft.banner.stripe_downleft.magenta": "Bond Majenta Kledh",
  "block.minecraft.banner.stripe_downleft.orange": "Bond Rudhvelyn Kledh",
  "block.minecraft.banner.stripe_downleft.pink": "Bond Rudhwynn Kledh",
  "block.minecraft.banner.stripe_downleft.purple": "Bond Purpur Kledh",
  "block.minecraft.banner.stripe_downleft.red": "Bond Rudh Kledh",
  "block.minecraft.banner.stripe_downleft.white": "Bond Gwynn Kledh",
  "block.minecraft.banner.stripe_downleft.yellow": "Bond Melyn Kledh",
  "block.minecraft.banner.stripe_downright.black": "Bond Du",
  "block.minecraft.banner.stripe_downright.blue": "Bond Glas",
  "block.minecraft.banner.stripe_downright.brown": "Bond Gell",
  "block.minecraft.banner.stripe_downright.cyan": "Bond Glaswyrdh",
  "block.minecraft.banner.stripe_downright.gray": "Bond Loos",
  "block.minecraft.banner.stripe_downright.green": "Bond Gwyrdh",
  "block.minecraft.banner.stripe_downright.light_blue": "Bond Glaswynn",
  "block.minecraft.banner.stripe_downright.light_gray": "Bond Gwynnloos",
  "block.minecraft.banner.stripe_downright.lime": "Bond Gwyrdhwynn",
  "block.minecraft.banner.stripe_downright.magenta": "Bond Majenta",
  "block.minecraft.banner.stripe_downright.orange": "Bond Rudhvelyn",
  "block.minecraft.banner.stripe_downright.pink": "Bond Rudhwynn",
  "block.minecraft.banner.stripe_downright.purple": "Bond Purpur",
  "block.minecraft.banner.stripe_downright.red": "Bond Rudh",
  "block.minecraft.banner.stripe_downright.white": "Bond Gwynn",
  "block.minecraft.banner.stripe_downright.yellow": "Bond Melyn",
  "block.minecraft.banner.stripe_left.black": "Peul Du Dyghow",
  "block.minecraft.banner.stripe_left.blue": "Peul Glas Dyghow",
  "block.minecraft.banner.stripe_left.brown": "Peul Gell Dyghow",
  "block.minecraft.banner.stripe_left.cyan": "Peul Glaswyrdh Dyghow",
  "block.minecraft.banner.stripe_left.gray": "Peul Loos Dyghow",
  "block.minecraft.banner.stripe_left.green": "Peul Gwyrdh Dyghow",
  "block.minecraft.banner.stripe_left.light_blue": "Peul Glaswynn Dyghow",
  "block.minecraft.banner.stripe_left.light_gray": "Peul Gwynnloos Dyghow",
  "block.minecraft.banner.stripe_left.lime": "Peul Gwyrdhwynn Dyghow",
  "block.minecraft.banner.stripe_left.magenta": "Peul Majenta Dyghow",
  "block.minecraft.banner.stripe_left.orange": "Peul Rudhvelyn Dyghow",
  "block.minecraft.banner.stripe_left.pink": "Peul Rudhwynn Dyghow",
  "block.minecraft.banner.stripe_left.purple": "Peul Purpur Dyghow",
  "block.minecraft.banner.stripe_left.red": "Peul Rudh Dyghow",
  "block.minecraft.banner.stripe_left.white": "Peul Gwynn Dyghow",
  "block.minecraft.banner.stripe_left.yellow": "Peul Melyn Dyghow",
  "block.minecraft.banner.stripe_middle.black": "Fess Du",
  "block.minecraft.banner.stripe_middle.blue": "Fess Glas",
  "block.minecraft.banner.stripe_middle.brown": "Fess Gell",
  "block.minecraft.banner.stripe_middle.cyan": "Fess Glaswyrdh",
  "block.minecraft.banner.stripe_middle.gray": "Fess Loos",
  "block.minecraft.banner.stripe_middle.green": "Fess Gwyrdh",
  "block.minecraft.banner.stripe_middle.light_blue": "Fess Glaswynn",
  "block.minecraft.banner.stripe_middle.light_gray": "Fess Gwynnloos",
  "block.minecraft.banner.stripe_middle.lime": "Fess Gwyrdhwynn",
  "block.minecraft.banner.stripe_middle.magenta": "Fess Majenta",
  "block.minecraft.banner.stripe_middle.orange": "Fess Rudhvelyn",
  "block.minecraft.banner.stripe_middle.pink": "Fess Rudhvelyn",
  "block.minecraft.banner.stripe_middle.purple": "Fess Purpur",
  "block.minecraft.banner.stripe_middle.red": "Fess Rudh",
  "block.minecraft.banner.stripe_middle.white": "Fess Gwyn",
  "block.minecraft.banner.stripe_middle.yellow": "Fess Melyn",
  "block.minecraft.banner.stripe_right.black": "Peul Du Kledh",
  "block.minecraft.banner.stripe_right.blue": "Peul Glas Kledh",
  "block.minecraft.banner.stripe_right.brown": "Peul Gell Kledh",
  "block.minecraft.banner.stripe_right.cyan": "Peul Glaswyrdh Kledh",
  "block.minecraft.banner.stripe_right.gray": "Peul Loos Kledh",
  "block.minecraft.banner.stripe_right.green": "Peul Gwyrdh Kledh",
  "block.minecraft.banner.stripe_right.light_blue": "Peul Glaswynn Kledh",
  "block.minecraft.banner.stripe_right.light_gray": "Peul Gwynnloos Kledh",
  "block.minecraft.banner.stripe_right.lime": "Peul Gwyrdhwynn Kledh",
  "block.minecraft.banner.stripe_right.magenta": "Peul Majenta Kledh",
  "block.minecraft.banner.stripe_right.orange": "Peul Rudhvelyn Kledh",
  "block.minecraft.banner.stripe_right.pink": "Peul Rudhwynn Kledh",
  "block.minecraft.banner.stripe_right.purple": "Peul Purpur Kledh",
  "block.minecraft.banner.stripe_right.red": "Peul Rudh Kledh",
  "block.minecraft.banner.stripe_right.white": "Peul Gwynn Kledh",
  "block.minecraft.banner.stripe_right.yellow": "Peul Melyn Kledh",
  "block.minecraft.banner.stripe_top.black": "Chyf Du",
  "block.minecraft.banner.stripe_top.blue": "Chyf Glas",
  "block.minecraft.banner.stripe_top.brown": "Chyf Gell",
  "block.minecraft.banner.stripe_top.cyan": "Chyf Glaswyrdh",
  "block.minecraft.banner.stripe_top.gray": "Chyf Loos",
  "block.minecraft.banner.stripe_top.green": "Chyf Gwyrdh",
  "block.minecraft.banner.stripe_top.light_blue": "Chyf Glaswynn",
  "block.minecraft.banner.stripe_top.light_gray": "Chyf Gwynnloos",
  "block.minecraft.banner.stripe_top.lime": "Chyf Gwyrdhwynn",
  "block.minecraft.banner.stripe_top.magenta": "Chyf Majenta",
  "block.minecraft.banner.stripe_top.orange": "Chyf Rudhvelyn",
  "block.minecraft.banner.stripe_top.pink": "Chyf Rudhwynn",
  "block.minecraft.banner.stripe_top.purple": "Chyf Purpur",
  "block.minecraft.banner.stripe_top.red": "Chyf Rudh",
  "block.minecraft.banner.stripe_top.white": "Chyf Gwynn",
  "block.minecraft.banner.stripe_top.yellow": "Chyf Melyn",
  "block.minecraft.banner.triangle_bottom.black": "Kebren Dhu",
  "block.minecraft.banner.triangle_bottom.blue": "Kebren Las",
  "block.minecraft.banner.triangle_bottom.brown": "Kebren Ell",
  "block.minecraft.banner.triangle_bottom.cyan": "Kebren Laswyrdh",
  "block.minecraft.banner.triangle_bottom.gray": "Kebren Loos",
  "block.minecraft.banner.triangle_bottom.green": "Kebren Wyrdh",
  "block.minecraft.banner.triangle_bottom.light_blue": "Kebren Laswynn",
  "block.minecraft.banner.triangle_bottom.light_gray": "Kebren Wynnloos",
  "block.minecraft.banner.triangle_bottom.lime": "Kebren Wyrdhwynn",
  "block.minecraft.banner.triangle_bottom.magenta": "Kebren Vajenta",
  "block.minecraft.banner.triangle_bottom.orange": "Kebren Rudhvelyn",
  "block.minecraft.banner.triangle_bottom.pink": "Kebren Rudhwynn",
  "block.minecraft.banner.triangle_bottom.purple": "Kebren Burpur",
  "block.minecraft.banner.triangle_bottom.red": "Kebren Rudh",
  "block.minecraft.banner.triangle_bottom.white": "Kebren Wynn",
  "block.minecraft.banner.triangle_bottom.yellow": "Kebren Velyn",
  "block.minecraft.banner.triangle_top.black": "Kebren Dhu Kildennys",
  "block.minecraft.banner.triangle_top.blue": "Kebren Las Kildennys",
  "block.minecraft.banner.triangle_top.brown": "Kebren Ell Kildennys",
  "block.minecraft.banner.triangle_top.cyan": "Kebren Laswyrdh Kildennys",
  "block.minecraft.banner.triangle_top.gray": "Kebren Loos Kildennys",
  "block.minecraft.banner.triangle_top.green": "Kebren Wyrdh Kildennys",
  "block.minecraft.banner.triangle_top.light_blue": "Kebren Laswynn Kildennys",
  "block.minecraft.banner.triangle_top.light_gray": "Kebren Wynnloos Kildennys",
  "block.minecraft.banner.triangle_top.lime": "Kebren Wyrdhwynn Kildennys",
  "block.minecraft.banner.triangle_top.magenta": "Kebren Vajenta Kildennys",
  "block.minecraft.banner.triangle_top.orange": "Kebren Rudhvelyn Kildennys",
  "block.minecraft.banner.triangle_top.pink": "Kebren Rudhwynn Kildennys",
  "block.minecraft.banner.triangle_top.purple": "Kebren Burpur Kildennys",
  "block.minecraft.banner.triangle_top.red": "Kebren Rudh Kildennys",
  "block.minecraft.banner.triangle_top.white": "Kebren Wynn Kildennys",
  "block.minecraft.banner.triangle_top.yellow": "Kebren Velyn Kildennys",
  "block.minecraft.banner.triangles_bottom.black": "Goles Du Kribys",
  "block.minecraft.banner.triangles_bottom.blue": "Goles Glas Kribys",
  "block.minecraft.banner.triangles_bottom.brown": "Goles Gell Kribys",
  "block.minecraft.banner.triangles_bottom.cyan": "Goles Glaswyrdh Kribys",
  "block.minecraft.banner.triangles_bottom.gray": "Goles Loos Kribys",
  "block.minecraft.banner.triangles_bottom.green": "Goles Gwyrdh Kribys",
  "block.minecraft.banner.triangles_bottom.light_blue": "Goles Glaswynn Kribys",
  "block.minecraft.banner.triangles_bottom.light_gray": "Goles Gwynnloos Kribys",
  "block.minecraft.banner.triangles_bottom.lime": "Goles Gwyrdhwynn Kribys",
  "block.minecraft.banner.triangles_bottom.magenta": "Goles Majenta Kribys",
  "block.minecraft.banner.triangles_bottom.orange": "Goles Rudhvelyn Kribys",
  "block.minecraft.banner.triangles_bottom.pink": "Goles Rudhwynn Kribys",
  "block.minecraft.banner.triangles_bottom.purple": "Goles Purpur Kribys",
  "block.minecraft.banner.triangles_bottom.red": "Goles Rudh Kribys",
  "block.minecraft.banner.triangles_bottom.white": "Goles Gwynn Kribys",
  "block.minecraft.banner.triangles_bottom.yellow": "Goles Melyn Kribys",
  "block.minecraft.banner.triangles_top.black": "Chyf Du Kribys",
  "block.minecraft.banner.triangles_top.blue": "Chyf Glas Kribys",
  "block.minecraft.banner.triangles_top.brown": "Chyf Gell Kribys",
  "block.minecraft.banner.triangles_top.cyan": "Chyf Glaswyrdh Kribys",
  "block.minecraft.banner.triangles_top.gray": "Chyf Loos Kribys",
  "block.minecraft.banner.triangles_top.green": "Chyf Gwyrdh Kribys",
  "block.minecraft.banner.triangles_top.light_blue": "Chyf Glaswynn Kribys",
  "block.minecraft.banner.triangles_top.light_gray": "Chyf Gwynnloos Kribys",
  "block.minecraft.banner.triangles_top.lime": "Chyf Gwyrdhwynn Kribys",
  "block.minecraft.banner.triangles_top.magenta": "Chyf Majenta Kribys",
  "block.minecraft.banner.triangles_top.orange": "Chyf Rudhvelyn Kribys",
  "block.minecraft.banner.triangles_top.pink": "Chyf Rudhwynn Kribys",
  "block.minecraft.banner.triangles_top.purple": "Chyf Purpur Kribys",
  "block.minecraft.banner.triangles_top.red": "Chyf Rudh Kribys",
  "block.minecraft.banner.triangles_top.white": "Chyf Gwynn Kribys",
  "block.minecraft.banner.triangles_top.yellow": "Chyf Melyn Kribys",
  "block.minecraft.barrel": "Balyer",
  "block.minecraft.barrier": "Lett",
  "block.minecraft.basalt": "Pyllargarrek",
  "block.minecraft.beacon": "Golowva",
  "block.minecraft.beacon.primary": "Nerth Kynsa",
  "block.minecraft.beacon.secondary": "Nerth Nessa",
  "block.minecraft.bed.no_sleep": "Ty a yll koska yn nos po yn tewedhow hepken",
  "block.minecraft.bed.not_safe": "Ny yll'ta koska lemmyn; yma euthviles yn ogas",
  "block.minecraft.bed.obstructed": "An gweli ma yw lettys",
  "block.minecraft.bed.occupied": "Yma nebonen y'n gweli ma",
  "block.minecraft.bed.too_far_away": "Ny yll'ta koska lemmyn; yth yw an gweli re bell ahanas",
  "block.minecraft.bedrock": "Bengarrek",
  "block.minecraft.bee_nest": "Neyth Gwenen",
  "block.minecraft.beehive": "Kowel Gwenen",
  "block.minecraft.beetroots": "Betys Rudh",
  "block.minecraft.bell": "Klogh",
  "block.minecraft.big_dripleaf": "Delen-Dhevera Bras",
  "block.minecraft.big_dripleaf_stem": "Garen Dhelen-Dhevera Bras",
  "block.minecraft.birch_button": "Boton Besow",
  "block.minecraft.birch_door": "Daras Besow",
  "block.minecraft.birch_fence": "Ke Besow",
  "block.minecraft.birch_fence_gate": "Yet Ke Besow",
  "block.minecraft.birch_hanging_sign": "Arwodh-Gregi Besow",
  "block.minecraft.birch_leaves": "Del Besow",
  "block.minecraft.birch_log": "Kyf Besow",
  "block.minecraft.birch_planks": "Estyl Besow",
  "block.minecraft.birch_pressure_plate": "Plat Gwaskedh Besow",
  "block.minecraft.birch_sapling": "Besowen Yowynk",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Arwodh Vesow",
  "block.minecraft.birch_slab": "Leghen Vesow",
  "block.minecraft.birch_stairs": "Grisyow Besow",
  "block.minecraft.birch_trapdoor": "Lo an Jowl Besow",
  "block.minecraft.birch_wall_hanging_sign": "Arwodh-Gregi Fos Besow",
  "block.minecraft.birch_wall_sign": "Arwodh Fos Besow",
  "block.minecraft.birch_wood": "Prenn Besow",
  "block.minecraft.black_banner": "Baner Du",
  "block.minecraft.black_bed": "Gweli Du",
  "block.minecraft.black_candle": "Kantol Dhu",
  "block.minecraft.black_candle_cake": "Tesen gans Kantol Dhu",
  "block.minecraft.black_carpet": "Leurlen Dhu",
  "block.minecraft.black_concrete": "Kestevyn Du",
  "block.minecraft.black_concrete_powder": "Ponn Kestevyn Du",
  "block.minecraft.black_glazed_terracotta": "Pri Pebys Gwedrys Du",
  "block.minecraft.black_shulker_box": "Boks Shulker Du",
  "block.minecraft.black_stained_glass": "Gweder Nammys Du",
  "block.minecraft.black_stained_glass_pane": "Kwarel Nammys Du",
  "block.minecraft.black_terracotta": "Pri Pebys Du",
  "block.minecraft.black_wool": "Gwlan Du",
  "block.minecraft.blackstone": "Duven",
  "block.minecraft.blackstone_slab": "Leghen Dhuven",
  "block.minecraft.blackstone_stairs": "Grisyow Duven",
  "block.minecraft.blackstone_wall": "Fos Dhuven",
  "block.minecraft.blast_furnace": "Fog Hwyth",
  "block.minecraft.blue_banner": "Baner Glas",
  "block.minecraft.blue_bed": "Gweli Glas",
  "block.minecraft.blue_candle": "Kantol Las",
  "block.minecraft.blue_candle_cake": "Tesen gans Kantol Las",
  "block.minecraft.blue_carpet": "Leurlen Las",
  "block.minecraft.blue_concrete": "Kestevyn Glas",
  "block.minecraft.blue_concrete_powder": "Ponn Kestevyn Glas",
  "block.minecraft.blue_glazed_terracotta": "Pri Pebys Gwedrys Glas",
  "block.minecraft.blue_ice": "Rew Glas",
  "block.minecraft.blue_orchid": "Tegyrinen Las",
  "block.minecraft.blue_shulker_box": "Boks Shulker Glas",
  "block.minecraft.blue_stained_glass": "Gweder Nammys Glas",
  "block.minecraft.blue_stained_glass_pane": "Kwarel Nammys Glas",
  "block.minecraft.blue_terracotta": "Pri Pebys Glas",
  "block.minecraft.blue_wool": "Gwlan Glas",
  "block.minecraft.bone_block": "Stock Askorn",
  "block.minecraft.bookshelf": "Argh Lyvrow",
  "block.minecraft.brain_coral": "Korel Ympynnyon",
  "block.minecraft.brain_coral_block": "Stock Korel Ympynnyon",
  "block.minecraft.brain_coral_fan": "Fan Korel Ympynnyon",
  "block.minecraft.brain_coral_wall_fan": "Fan Fos Korel Ympynnyon",
  "block.minecraft.brewing_stand": "Sav Braga",
  "block.minecraft.brick_slab": "Leghen Vryck",
  "block.minecraft.brick_stairs": "Grisyow Bryck",
  "block.minecraft.brick_wall": "Fos Vryck",
  "block.minecraft.bricks": "Bryckys",
  "block.minecraft.brown_banner": "Baner Gell",
  "block.minecraft.brown_bed": "Gweli Gell",
  "block.minecraft.brown_candle": "Kantol Ell",
  "block.minecraft.brown_candle_cake": "Tesen gans Kantol Ell",
  "block.minecraft.brown_carpet": "Leurlen Ell",
  "block.minecraft.brown_concrete": "Kestevyn Gell",
  "block.minecraft.brown_concrete_powder": "Ponn Kestevyn Gell",
  "block.minecraft.brown_glazed_terracotta": "Pri Pebys Gwedrys Gell",
  "block.minecraft.brown_mushroom": "Skavel Gronek Ell",
  "block.minecraft.brown_mushroom_block": "Stock Skavel Gronek Ell",
  "block.minecraft.brown_shulker_box": "Boks Shulker Gell",
  "block.minecraft.brown_stained_glass": "Gweder Nammys Gell",
  "block.minecraft.brown_stained_glass_pane": "Kwarel Nammys Gell",
  "block.minecraft.brown_terracotta": "Pri Pebys Gell",
  "block.minecraft.brown_wool": "Gwlan Gell",
  "block.minecraft.bubble_column": "Koloven Hwethen",
  "block.minecraft.bubble_coral": "Korel Hwethen",
  "block.minecraft.bubble_coral_block": "Stock Korel Hwethen",
  "block.minecraft.bubble_coral_fan": "Fan Korel Hwethen",
  "block.minecraft.bubble_coral_wall_fan": "Fan Fos Korel Hwethen",
  "block.minecraft.budding_amethyst": "Amethyst ow Tevi",
  "block.minecraft.bush": "Prysken",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Bleujen Kaktus",
  "block.minecraft.cake": "Tesen",
  "block.minecraft.calcite": "Kalsit",
  "block.minecraft.calibrated_sculk_sensor": "Sensour Skulk Finhes",
  "block.minecraft.campfire": "Tan Kamp",
  "block.minecraft.candle": "Kantol",
  "block.minecraft.candle_cake": "Tesen gans Kantol",
  "block.minecraft.carrots": "Karetys",
  "block.minecraft.cartography_table": "Moos Vappa",
  "block.minecraft.carved_pumpkin": "Pompyon Kervys",
  "block.minecraft.cauldron": "Chek",
  "block.minecraft.cave_air": "Ayr Kav",
  "block.minecraft.cave_vines": "Gwinbrennyer Kav",
  "block.minecraft.cave_vines_plant": "Plans Gwinbrennyer Kav",
  "block.minecraft.chain": "Chayn",
  "block.minecraft.chain_command_block": "Stock Gorhemmyn Chayn",
  "block.minecraft.cherry_button": "Boton Kereswydh",
  "block.minecraft.cherry_door": "Daras Kereswydh",
  "block.minecraft.cherry_fence": "Ke Kereswydh",
  "block.minecraft.cherry_fence_gate": "Yet Ke Kereswydh",
  "block.minecraft.cherry_hanging_sign": "Arwodh-Gregi Kereswydh",
  "block.minecraft.cherry_leaves": "Del Kereswydh",
  "block.minecraft.cherry_log": "Kyf Kereswydh",
  "block.minecraft.cherry_planks": "Estyl Kereswydh",
  "block.minecraft.cherry_pressure_plate": "Plat Gwaskedh Kereswydh",
  "block.minecraft.cherry_sapling": "Kereswydhen Yowynk",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Arwodh Kereswydh",
  "block.minecraft.cherry_slab": "Leghen Kereswydh",
  "block.minecraft.cherry_stairs": "Grisyow Kereswydh",
  "block.minecraft.cherry_trapdoor": "Lo an Jowl Kereswydh",
  "block.minecraft.cherry_wall_hanging_sign": "Arwodh-Gregi Fos Kereswydh",
  "block.minecraft.cherry_wall_sign": "Arwodh Fos Kereswydh",
  "block.minecraft.cherry_wood": "Prenn Kereswydh",
  "block.minecraft.chest": "Kist",
  "block.minecraft.chipped_anvil": "Anwan Asklosys",
  "block.minecraft.chiseled_bookshelf": "Argh Lyvrow Kervys",
  "block.minecraft.chiseled_copper": "Kober Kervys",
  "block.minecraft.chiseled_deepslate": "Downgyllas Kervys",
  "block.minecraft.chiseled_nether_bricks": "Bryckys Nether Kervys",
  "block.minecraft.chiseled_polished_blackstone": "Duven Polsys Kervys",
  "block.minecraft.chiseled_quartz_block": "Stock Kanndir Kervys",
  "block.minecraft.chiseled_red_sandstone": "Krag Rudh Kervys",
  "block.minecraft.chiseled_resin_bricks": "Bryckys Rosin Kervys",
  "block.minecraft.chiseled_sandstone": "Krag Kervys",
  "block.minecraft.chiseled_stone_bricks": "Bryckys Meyn Kervys",
  "block.minecraft.chiseled_tuff": "Tuff Kervys",
  "block.minecraft.chiseled_tuff_bricks": "Bryckys Tuff Kervys",
  "block.minecraft.chorus_flower": "Bleujen Goros",
  "block.minecraft.chorus_plant": "Losowen Koros",
  "block.minecraft.clay": "Pri",
  "block.minecraft.closed_eyeblossom": "Lagasvleujen Dheges",
  "block.minecraft.coal_block": "Stock Glow",
  "block.minecraft.coal_ore": "Moon Glow",
  "block.minecraft.coarse_dirt": "Dor Garow",
  "block.minecraft.cobbled_deepslate": "Downgyllas Kaunsys",
  "block.minecraft.cobbled_deepslate_slab": "Leghen Dhowngyllas Kaunsys",
  "block.minecraft.cobbled_deepslate_stairs": "Grisyow Downgyllas Kaunsys",
  "block.minecraft.cobbled_deepslate_wall": "Fos Dhowngyllas Kaunsys",
  "block.minecraft.cobblestone": "Men Kauns",
  "block.minecraft.cobblestone_slab": "Leghen Ven Kauns",
  "block.minecraft.cobblestone_stairs": "Grisyow Men Kauns",
  "block.minecraft.cobblestone_wall": "Fos Ven Kauns",
  "block.minecraft.cobweb": "Gwias Kevnis",
  "block.minecraft.cocoa": "Kokoa",
  "block.minecraft.command_block": "Stock Gorhemmyn",
  "block.minecraft.comparator": "Komparyer Rudhven",
  "block.minecraft.composter": "Teylell",
  "block.minecraft.conduit": "Gooth",
  "block.minecraft.copper_bars": "Barrys Kober",
  "block.minecraft.copper_block": "Stock Kober",
  "block.minecraft.copper_bulb": "Bollen Gober",
  "block.minecraft.copper_chain": "Chayn Kober",
  "block.minecraft.copper_chest": "Argh Gober",
  "block.minecraft.copper_door": "Daras Kober",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Maglen Gober",
  "block.minecraft.copper_lantern": "Lugarn Kober",
  "block.minecraft.copper_ore": "Moon Kober",
  "block.minecraft.copper_torch": "Faglen Gober",
  "block.minecraft.copper_trapdoor": "Lo an Jowl Kober",
  "block.minecraft.copper_wall_torch": "Faglen Fos Gober",
  "block.minecraft.cornflower": "Glasik",
  "block.minecraft.cracked_deepslate_bricks": "Bryckys Downgyllas Krackys",
  "block.minecraft.cracked_deepslate_tiles": "Prilegh Downgyllas Krackys",
  "block.minecraft.cracked_nether_bricks": "Bryckys Nether Krackys",
  "block.minecraft.cracked_polished_blackstone_bricks": "Bryckys Duven Polsys Krackys",
  "block.minecraft.cracked_stone_bricks": "Bryckys Men Krackys",
  "block.minecraft.crafter": "Kreftyer",
  "block.minecraft.crafting_table": "Moos Kreftya",
  "block.minecraft.creaking_heart": "Kolon-Wighal",
  "block.minecraft.creeper_head": "Penn Kreeper",
  "block.minecraft.creeper_wall_head": "Penn Kreeper rag Fos",
  "block.minecraft.crimson_button": "Boton Kogh",
  "block.minecraft.crimson_door": "Daras Kogh",
  "block.minecraft.crimson_fence": "Ke Kogh",
  "block.minecraft.crimson_fence_gate": "Yet Ke Kogh",
  "block.minecraft.crimson_fungus": "Fong Kogh",
  "block.minecraft.crimson_hanging_sign": "Arwodh-Gregi Kogh",
  "block.minecraft.crimson_hyphae": "Trethow Kogh",
  "block.minecraft.crimson_nylium": "Nylium Kogh",
  "block.minecraft.crimson_planks": "Estyl Kogh",
  "block.minecraft.crimson_pressure_plate": "Plat Gwaskedh Kogh",
  "block.minecraft.crimson_roots": "Gwreydh Kogh",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Arwodh Kogh",
  "block.minecraft.crimson_slab": "Leghen Gogh",
  "block.minecraft.crimson_stairs": "Grisyow Kogh",
  "block.minecraft.crimson_stem": "Garen Gogh",
  "block.minecraft.crimson_trapdoor": "Lo an Jowl Kogh",
  "block.minecraft.crimson_wall_hanging_sign": "Arwodh-Gregi Fos Kogh",
  "block.minecraft.crimson_wall_sign": "Arwodh Fos Kogh",
  "block.minecraft.crying_obsidian": "Duweder Ola",
  "block.minecraft.cut_copper": "Kober Treghys",
  "block.minecraft.cut_copper_slab": "Leghen Gober Treghys",
  "block.minecraft.cut_copper_stairs": "Grisyow Kober Treghys",
  "block.minecraft.cut_red_sandstone": "Krag Rudh Treghys",
  "block.minecraft.cut_red_sandstone_slab": "Leghen Grag Rudh Treghys",
  "block.minecraft.cut_sandstone": "Krag Treghys",
  "block.minecraft.cut_sandstone_slab": "Leghen Grag Treghys",
  "block.minecraft.cyan_banner": "Baner Glaswyrdh",
  "block.minecraft.cyan_bed": "Gweli Glaswyrdh",
  "block.minecraft.cyan_candle": "Kantol Laswyrdh",
  "block.minecraft.cyan_candle_cake": "Tesen gans Kantol Laswyrdh",
  "block.minecraft.cyan_carpet": "Leurlen Glaswyrdh",
  "block.minecraft.cyan_concrete": "Kestevyn Glaswyrdh",
  "block.minecraft.cyan_concrete_powder": "Ponn Kestevyn Glaswyrdh",
  "block.minecraft.cyan_glazed_terracotta": "Pri Pebys Gwedrys Glaswyrdh",
  "block.minecraft.cyan_shulker_box": "Boks Shulker Glaswyrdh",
  "block.minecraft.cyan_stained_glass": "Gweder Nammys Glaswyrdh",
  "block.minecraft.cyan_stained_glass_pane": "Kwarel Nammys Glaswyrdh",
  "block.minecraft.cyan_terracotta": "Pri Pebys Glaswyrdh",
  "block.minecraft.cyan_wool": "Gwlan Glaswyrdh",
  "block.minecraft.damaged_anvil": "Anwan Kisys",
  "block.minecraft.dandelion": "Dans Lew",
  "block.minecraft.dark_oak_button": "Boton Dar Tewal",
  "block.minecraft.dark_oak_door": "Daras Dar Tewal",
  "block.minecraft.dark_oak_fence": "Ke Dar Tewal",
  "block.minecraft.dark_oak_fence_gate": "Yet Ke Dar Tewal",
  "block.minecraft.dark_oak_hanging_sign": "Arwodh-Gregi Dar Tewal",
  "block.minecraft.dark_oak_leaves": "Del Dar Tewal",
  "block.minecraft.dark_oak_log": "Kyf Dar Tewal",
  "block.minecraft.dark_oak_planks": "Estyl Dar Tewal",
  "block.minecraft.dark_oak_pressure_plate": "Plat Gwaskedh Dar Tewal",
  "block.minecraft.dark_oak_sapling": "Dar Tewal Yowynk",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Arwodh Dhar Tewal",
  "block.minecraft.dark_oak_slab": "Leghen Dhar Tewal",
  "block.minecraft.dark_oak_stairs": "Grisyow Dar Tewal",
  "block.minecraft.dark_oak_trapdoor": "Lo an Jowl Dar Tewal",
  "block.minecraft.dark_oak_wall_hanging_sign": "Arwodh-Gregi Fos Dar Tewal",
  "block.minecraft.dark_oak_wall_sign": "Arwodh Fos Dar Tewal",
  "block.minecraft.dark_oak_wood": "Prenn Dar Tewal",
  "block.minecraft.dark_prismarine": "Prismarin Tewal",
  "block.minecraft.dark_prismarine_slab": "Leghen Brismarin Tewal",
  "block.minecraft.dark_prismarine_stairs": "Grisyow Prismarin Tewal",
  "block.minecraft.daylight_detector": "Sensour Golow an Howl",
  "block.minecraft.dead_brain_coral": "Korel Ympynnyon Marow",
  "block.minecraft.dead_brain_coral_block": "Stock Korel Ympynnyon Marow",
  "block.minecraft.dead_brain_coral_fan": "Fan Korel Ympynnyon Marow",
  "block.minecraft.dead_brain_coral_wall_fan": "Fan Fos Korel Ympynnyon Marow",
  "block.minecraft.dead_bubble_coral": "Korel Hwethen Marow",
  "block.minecraft.dead_bubble_coral_block": "Stock Korel Hwethen Marow",
  "block.minecraft.dead_bubble_coral_fan": "Fan Korel Hwethen Marow",
  "block.minecraft.dead_bubble_coral_wall_fan": "Fan Fos Korel Hwethen Marow",
  "block.minecraft.dead_bush": "Prysken Varow",
  "block.minecraft.dead_fire_coral": "Korel Tan Marow",
  "block.minecraft.dead_fire_coral_block": "Stock Korel Tan Marow",
  "block.minecraft.dead_fire_coral_fan": "Fan Korel Tan Marow",
  "block.minecraft.dead_fire_coral_wall_fan": "Fan Fos Korel Tan Marow",
  "block.minecraft.dead_horn_coral": "Korel Korn Marow",
  "block.minecraft.dead_horn_coral_block": "Stock Korel Korn Marow",
  "block.minecraft.dead_horn_coral_fan": "Fan Korel Korn Marow",
  "block.minecraft.dead_horn_coral_wall_fan": "Fan Fos Korel Korn Marow",
  "block.minecraft.dead_tube_coral": "Korel Piben Marow",
  "block.minecraft.dead_tube_coral_block": "Stock Korel Piben Marow",
  "block.minecraft.dead_tube_coral_fan": "Fan Korel Piben Marow",
  "block.minecraft.dead_tube_coral_wall_fan": "Fan Fos Korel Piben Marow",
  "block.minecraft.decorated_pot": "Pott Afinys",
  "block.minecraft.deepslate": "Downgyllas",
  "block.minecraft.deepslate_brick_slab": "Leghen Vryck Downgyllas",
  "block.minecraft.deepslate_brick_stairs": "Grisyow Bryckys Downgyllas",
  "block.minecraft.deepslate_brick_wall": "Fos Vryck Downgyllas",
  "block.minecraft.deepslate_bricks": "Bryckys Downgyllas",
  "block.minecraft.deepslate_coal_ore": "Moon Glow Downgyllas",
  "block.minecraft.deepslate_copper_ore": "Moon Kober Downgyllas",
  "block.minecraft.deepslate_diamond_ore": "Moon Adamant Downgyllas",
  "block.minecraft.deepslate_emerald_ore": "Moon Gwerem Downgyllas",
  "block.minecraft.deepslate_gold_ore": "Moon Owr Downgyllas",
  "block.minecraft.deepslate_iron_ore": "Moon Horn Downgyllas",
  "block.minecraft.deepslate_lapis_ore": "Moon Lapis Lazuli Downgyllas",
  "block.minecraft.deepslate_redstone_ore": "Moon Rudhven Downgyllas",
  "block.minecraft.deepslate_tile_slab": "Leghen Brilegh Downgyllas",
  "block.minecraft.deepslate_tile_stairs": "Grisyow Prilegh Downgyllas",
  "block.minecraft.deepslate_tile_wall": "Fos Prilegh Downgyllas",
  "block.minecraft.deepslate_tiles": "Prilegh Downgyllas",
  "block.minecraft.detector_rail": "Hyns Horn Helerghi",
  "block.minecraft.diamond_block": "Stock Adamant",
  "block.minecraft.diamond_ore": "Moon Adamant",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Leghen Dhiorit",
  "block.minecraft.diorite_stairs": "Grisyow Diorit",
  "block.minecraft.diorite_wall": "Fos Dhiorit",
  "block.minecraft.dirt": "Dor",
  "block.minecraft.dirt_path": "Hyns Dor",
  "block.minecraft.dispenser": "Lesrannell",
  "block.minecraft.dragon_egg": "Oy Dragon",
  "block.minecraft.dragon_head": "Penn Dragon",
  "block.minecraft.dragon_wall_head": "Penn Dragon Fos",
  "block.minecraft.dried_ghast": "Tarosvan Seghys",
  "block.minecraft.dried_kelp_block": "Stock Gommon Seghys",
  "block.minecraft.dripstone_block": "Stock Men-Devera",
  "block.minecraft.dropper": "Droppyer",
  "block.minecraft.emerald_block": "Stock Gwerem",
  "block.minecraft.emerald_ore": "Moon Gwerem",
  "block.minecraft.enchanting_table": "Moos Hus",
  "block.minecraft.end_gateway": "Porth an End",
  "block.minecraft.end_portal": "Porth an Diwedh",
  "block.minecraft.end_portal_frame": "Fram Porth an End",
  "block.minecraft.end_rod": "Gwelen an Diwedh",
  "block.minecraft.end_stone": "Men an Diwedh",
  "block.minecraft.end_stone_brick_slab": "Leghen Vryck Men an Diwedh",
  "block.minecraft.end_stone_brick_stairs": "Grisyow Bryck Men an Diwedh",
  "block.minecraft.end_stone_brick_wall": "Fos Vryck Men an Diwedh",
  "block.minecraft.end_stone_bricks": "Bryckys Men an Diwedh",
  "block.minecraft.ender_chest": "Kist an Diwedh",
  "block.minecraft.exposed_chiseled_copper": "Kober Godewedhys Kervys",
  "block.minecraft.exposed_copper": "Kober Godewedhys",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Bollen Gober Godewedhys",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Daras Kober Godewedhys",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Maglen Gober Godewedhys",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Lo an Jowl Kober Godewedhys",
  "block.minecraft.exposed_cut_copper": "Kober Treghys Godewedhys",
  "block.minecraft.exposed_cut_copper_slab": "Leghen Gober Treghys Godewedhys",
  "block.minecraft.exposed_cut_copper_stairs": "Grisyow Kober Treghys Godewedhys",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Bargen Tir",
  "block.minecraft.fern": "Redenen",
  "block.minecraft.fire": "Tan",
  "block.minecraft.fire_coral": "Korel Tan",
  "block.minecraft.fire_coral_block": "Stock Korel Tan",
  "block.minecraft.fire_coral_fan": "Fan Korel Tan",
  "block.minecraft.fire_coral_wall_fan": "Fan Fos Korel Tan",
  "block.minecraft.firefly_bush": "Prysken Hwil Tan",
  "block.minecraft.fletching_table": "Moos Sethweyth",
  "block.minecraft.flower_pot": "Pott",
  "block.minecraft.flowering_azalea": "Azalea ow Pleujyowa",
  "block.minecraft.flowering_azalea_leaves": "Del Azalea ow Pleujyowa",
  "block.minecraft.frogspawn": "Oyow Kwilkyn",
  "block.minecraft.frosted_ice": "Rew Nowydh",
  "block.minecraft.furnace": "Fog",
  "block.minecraft.gilded_blackstone": "Duven Owrek",
  "block.minecraft.glass": "Gweder",
  "block.minecraft.glass_pane": "Kwarel",
  "block.minecraft.glow_lichen": "Fongalgi-Splanna",
  "block.minecraft.glowstone": "Splannven",
  "block.minecraft.gold_block": "Stock Owr",
  "block.minecraft.gold_ore": "Moon Owr",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Growan",
  "block.minecraft.granite_slab": "Leghen Wrowan",
  "block.minecraft.granite_stairs": "Grisyow Growan",
  "block.minecraft.granite_wall": "Fos Wrowan",
  "block.minecraft.grass": "Gwels",
  "block.minecraft.grass_block": "Stock Gwels",
  "block.minecraft.gravel": "Grow",
  "block.minecraft.gray_banner": "Baner Loos",
  "block.minecraft.gray_bed": "Gweli Loos",
  "block.minecraft.gray_candle": "Kantol Loos",
  "block.minecraft.gray_candle_cake": "Tesen gans Kantol Loos",
  "block.minecraft.gray_carpet": "Leurlen Loos",
  "block.minecraft.gray_concrete": "Kestevyn Loos",
  "block.minecraft.gray_concrete_powder": "Ponn Kestevyn Loos",
  "block.minecraft.gray_glazed_terracotta": "Pri Pebys Gwedrys Loos",
  "block.minecraft.gray_shulker_box": "Boks Shulker Loos",
  "block.minecraft.gray_stained_glass": "Gweder Nammys Loos",
  "block.minecraft.gray_stained_glass_pane": "Kwarel Nammys Loos",
  "block.minecraft.gray_terracotta": "Pri Pebys Loos",
  "block.minecraft.gray_wool": "Gwlan Loos",
  "block.minecraft.green_banner": "Baner Gwyrdh",
  "block.minecraft.green_bed": "Gweli Gwyrdh",
  "block.minecraft.green_candle": "Kantol Wyrdh",
  "block.minecraft.green_candle_cake": "Tesen gans Kantol Wyrdh",
  "block.minecraft.green_carpet": "Leurlen Wyrdh",
  "block.minecraft.green_concrete": "Kestevyn Gwyrdh",
  "block.minecraft.green_concrete_powder": "Ponn Kestevyn Gwyrdh",
  "block.minecraft.green_glazed_terracotta": "Pri Pebys Gwedrys Gwyrdh",
  "block.minecraft.green_shulker_box": "Boks Shulker Gwyrdh",
  "block.minecraft.green_stained_glass": "Gweder Nammys Gwyrdh",
  "block.minecraft.green_stained_glass_pane": "Kwarel Nammys Gwyrdh",
  "block.minecraft.green_terracotta": "Pri Pebys Gwyrdh",
  "block.minecraft.green_wool": "Gwlan Gwyrdh",
  "block.minecraft.grindstone": "Men Mala",
  "block.minecraft.hanging_roots": "Gwreydh Kregi",
  "block.minecraft.hay_block": "Pusorn a Wora",
  "block.minecraft.heavy_core": "Kolonnen Boos",
  "block.minecraft.heavy_weighted_pressure_plate": "Plat Gwaskedh Poos",
  "block.minecraft.honey_block": "Stock Mel",
  "block.minecraft.honeycomb_block": "Stock Kriben Vel",
  "block.minecraft.hopper": "Korn-Dinewi",
  "block.minecraft.horn_coral": "Korel Korn",
  "block.minecraft.horn_coral_block": "Stock Korel Korn",
  "block.minecraft.horn_coral_fan": "Fan Korel Korn",
  "block.minecraft.horn_coral_wall_fan": "Fan Fos Korel Korn",
  "block.minecraft.ice": "Rew",
  "block.minecraft.infested_chiseled_stone_bricks": "Bryckys Men Plagys Gennys",
  "block.minecraft.infested_cobblestone": "Men Kauns Plagys",
  "block.minecraft.infested_cracked_stone_bricks": "Bryckys Men Plagys Krackys",
  "block.minecraft.infested_deepslate": "Downgyllas Plagys",
  "block.minecraft.infested_mossy_stone_bricks": "Bryckys Men Plagys Kewniek",
  "block.minecraft.infested_stone": "Men Plagys",
  "block.minecraft.infested_stone_bricks": "Bryckys Men Plagys",
  "block.minecraft.iron_bars": "Prennyer Horn",
  "block.minecraft.iron_block": "Stock Horn",
  "block.minecraft.iron_chain": "Chayn Horn",
  "block.minecraft.iron_door": "Daras Horn",
  "block.minecraft.iron_ore": "Moon Horn",
  "block.minecraft.iron_trapdoor": "Lo an Jowl Horn",
  "block.minecraft.jack_o_lantern": "Lugarn Pompyon",
  "block.minecraft.jigsaw": "Stock Mildam",
  "block.minecraft.jukebox": "Troyllyer",
  "block.minecraft.jungle_button": "Boton Gwylgos",
  "block.minecraft.jungle_door": "Daras Gwylgos",
  "block.minecraft.jungle_fence": "Ke Prenn Gwylgos",
  "block.minecraft.jungle_fence_gate": "Yet Ke Prenn Gwylgos",
  "block.minecraft.jungle_hanging_sign": "Arwodh-Gregi Gwylgos",
  "block.minecraft.jungle_leaves": "Del Gwylgos",
  "block.minecraft.jungle_log": "Kyf Gwylgos",
  "block.minecraft.jungle_planks": "Estyl Gwylgos",
  "block.minecraft.jungle_pressure_plate": "Plat Gwaskedh Gwylgos",
  "block.minecraft.jungle_sapling": "Gwedhen Yowynk Gwylgos",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Arwodh Wylgos",
  "block.minecraft.jungle_slab": "Leghen Wylgos",
  "block.minecraft.jungle_stairs": "Grisyow Gwylgos",
  "block.minecraft.jungle_trapdoor": "Lo an Jowl Gwylgos",
  "block.minecraft.jungle_wall_hanging_sign": "Arwodh-Gregi Fos Gwylgos",
  "block.minecraft.jungle_wall_sign": "Arwodh Fos Gwylgos",
  "block.minecraft.jungle_wood": "Prenn Gwylgos",
  "block.minecraft.kelp": "Gommon",
  "block.minecraft.kelp_plant": "Les Gommon",
  "block.minecraft.ladder": "Skeul",
  "block.minecraft.lantern": "Lugarn",
  "block.minecraft.lapis_block": "Stock Lapis Lazuli",
  "block.minecraft.lapis_ore": "Moon Lapis",
  "block.minecraft.large_amethyst_bud": "Egyn Amethyst Bras",
  "block.minecraft.large_fern": "Redenen Vras",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Chek Lava",
  "block.minecraft.leaf_litter": "Del Marow",
  "block.minecraft.lectern": "Lennva",
  "block.minecraft.lever": "Kolpes",
  "block.minecraft.light": "Golow",
  "block.minecraft.light_blue_banner": "Baner Glaswynn",
  "block.minecraft.light_blue_bed": "Gweli Glaswynn",
  "block.minecraft.light_blue_candle": "Kantol Laswynn",
  "block.minecraft.light_blue_candle_cake": "Tesen gans Kantol Laswyn",
  "block.minecraft.light_blue_carpet": "Leurlen Laswynn",
  "block.minecraft.light_blue_concrete": "Kestevyn Glaswynn",
  "block.minecraft.light_blue_concrete_powder": "Ponn Kestevyn Glaswynn",
  "block.minecraft.light_blue_glazed_terracotta": "Pri Pebys Gwedrys Glaswynn",
  "block.minecraft.light_blue_shulker_box": "Boks Shulker Glaswynn",
  "block.minecraft.light_blue_stained_glass": "Gweder Nammys Glaswynn",
  "block.minecraft.light_blue_stained_glass_pane": "Kwarel Nammys Glaswynn",
  "block.minecraft.light_blue_terracotta": "Pri Pebys Glaswynn",
  "block.minecraft.light_blue_wool": "Gwlan Glaswynn",
  "block.minecraft.light_gray_banner": "Baner Gwynnloos",
  "block.minecraft.light_gray_bed": "Gweli Gwynnloos",
  "block.minecraft.light_gray_candle": "Kantol Wynnloos",
  "block.minecraft.light_gray_candle_cake": "Tesen gans Kantol Wynnlos",
  "block.minecraft.light_gray_carpet": "Leurlen Wynnloos",
  "block.minecraft.light_gray_concrete": "Kestevyn Gwynnloos",
  "block.minecraft.light_gray_concrete_powder": "Ponn Kestevyn Gwynnloos",
  "block.minecraft.light_gray_glazed_terracotta": "Pri Pebys Gwedrys Gwynnloos",
  "block.minecraft.light_gray_shulker_box": "Boks Shulker Gwynnloos",
  "block.minecraft.light_gray_stained_glass": "Gweder Nammys Gwynnloos",
  "block.minecraft.light_gray_stained_glass_pane": "Kwarel Nammys Gwynnloos",
  "block.minecraft.light_gray_terracotta": "Pri Pebys Gwynnloos",
  "block.minecraft.light_gray_wool": "Gwlan Gwynnloos",
  "block.minecraft.light_weighted_pressure_plate": "Plat Gwaskedh Skav",
  "block.minecraft.lightning_rod": "Gwelen Lughes",
  "block.minecraft.lilac": "Bleujen Lilac",
  "block.minecraft.lily_of_the_valley": "Losow an Hav",
  "block.minecraft.lily_pad": "Padyn Lili",
  "block.minecraft.lime_banner": "Baner Gwyrdhwynn",
  "block.minecraft.lime_bed": "Gweli Gwynnwyrdh",
  "block.minecraft.lime_candle": "Kantol Wyrdhwynn",
  "block.minecraft.lime_candle_cake": "Tesen gans Kantol Wyrdhwyn",
  "block.minecraft.lime_carpet": "Leurlen Wynnwyrdh",
  "block.minecraft.lime_concrete": "Kestevyn Gwynnwyrdh",
  "block.minecraft.lime_concrete_powder": "Ponn Kestevyn Gwynnwyrdh",
  "block.minecraft.lime_glazed_terracotta": "Pri Pebys Gwedrys Gwynnwyrdh",
  "block.minecraft.lime_shulker_box": "Boks Shulker Gwynnwyrdh",
  "block.minecraft.lime_stained_glass": "Gweder Nammys Gwynnwyrdh",
  "block.minecraft.lime_stained_glass_pane": "Kwarel Nammys Gwynnwyrdh",
  "block.minecraft.lime_terracotta": "Pri Pebys Gwynnwyrdh",
  "block.minecraft.lime_wool": "Gwlan Gwynnwyrdh",
  "block.minecraft.lodestone": "Tenven",
  "block.minecraft.loom": "Starn Gwiader",
  "block.minecraft.magenta_banner": "Baner Majenta",
  "block.minecraft.magenta_bed": "Gweli Majenta",
  "block.minecraft.magenta_candle": "Kantol Vajenta",
  "block.minecraft.magenta_candle_cake": "Tesen gans Kantol Vajenta",
  "block.minecraft.magenta_carpet": "Leurlen Vajenta",
  "block.minecraft.magenta_concrete": "Kestevyn Majenta",
  "block.minecraft.magenta_concrete_powder": "Ponn Kestevyn Majenta",
  "block.minecraft.magenta_glazed_terracotta": "Pri Pebys Gwedrys Majenta",
  "block.minecraft.magenta_shulker_box": "Boks Shulker Majenta",
  "block.minecraft.magenta_stained_glass": "Gweder Nammys Majenta",
  "block.minecraft.magenta_stained_glass_pane": "Kwarel Nammys Majenta",
  "block.minecraft.magenta_terracotta": "Pri Pebys Majenta",
  "block.minecraft.magenta_wool": "Gwlan Majenta",
  "block.minecraft.magma_block": "Stock Magma",
  "block.minecraft.mangrove_button": "Boton Mangrof",
  "block.minecraft.mangrove_door": "Daras Mangrof",
  "block.minecraft.mangrove_fence": "Ke Mangrof",
  "block.minecraft.mangrove_fence_gate": "Yet Ke Mangrof",
  "block.minecraft.mangrove_hanging_sign": "Arwodh-Gregi Mangrov",
  "block.minecraft.mangrove_leaves": "Del Mangrof",
  "block.minecraft.mangrove_log": "Kyf Mangrof",
  "block.minecraft.mangrove_planks": "Estyl Mangrof",
  "block.minecraft.mangrove_pressure_plate": "Plat Gwaskedh Mangrof",
  "block.minecraft.mangrove_propagule": "Lesen Mangrof",
  "block.minecraft.mangrove_roots": "Gwreydh Mangrof",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Arwodh Mangrof",
  "block.minecraft.mangrove_slab": "Leghen Vangrof",
  "block.minecraft.mangrove_stairs": "Grisyow Mangrof",
  "block.minecraft.mangrove_trapdoor": "Lo an Jowl Mangrof",
  "block.minecraft.mangrove_wall_hanging_sign": "Arwodh-Gregi Fos Mangrov",
  "block.minecraft.mangrove_wall_sign": "Arwodh Fos Mangrof",
  "block.minecraft.mangrove_wood": "Prenn Mangrof",
  "block.minecraft.medium_amethyst_bud": "Egyn Amethyst Kres",
  "block.minecraft.melon": "Pompyon Hweg",
  "block.minecraft.melon_stem": "Garen Bompyon Hweg",
  "block.minecraft.moss_block": "Stock Kewni",
  "block.minecraft.moss_carpet": "Leurlen Gewni",
  "block.minecraft.mossy_cobblestone": "Men Kauns Kewniek",
  "block.minecraft.mossy_cobblestone_slab": "Leghen Ven Kauns Kewniek",
  "block.minecraft.mossy_cobblestone_stairs": "Grisyow Men Kauns Kewniek",
  "block.minecraft.mossy_cobblestone_wall": "Fos Ven Kauns Kewniek",
  "block.minecraft.mossy_stone_brick_slab": "Leghen Vryck Men Kewniek",
  "block.minecraft.mossy_stone_brick_stairs": "Grisyow Bryck Men Kewniek",
  "block.minecraft.mossy_stone_brick_wall": "Fos Vryck Men Kewniek",
  "block.minecraft.mossy_stone_bricks": "Bryckys Men Kewniek",
  "block.minecraft.moving_piston": "Pyston Gwayek",
  "block.minecraft.mud": "Leys",
  "block.minecraft.mud_brick_slab": "Leghen Vryckys Leys",
  "block.minecraft.mud_brick_stairs": "Grisyow Bryck Leys",
  "block.minecraft.mud_brick_wall": "Fos Vryckys Leys",
  "block.minecraft.mud_bricks": "Bryckys Leys",
  "block.minecraft.muddy_mangrove_roots": "Gwreydh Mangrof Leysek",
  "block.minecraft.mushroom_stem": "Garen Skavel Gronek",
  "block.minecraft.mycelium": "Towargh Tewl",
  "block.minecraft.nether_brick_fence": "Ke Bryckys Yfarngarrek",
  "block.minecraft.nether_brick_slab": "Leghen Vryck Nether",
  "block.minecraft.nether_brick_stairs": "Grisyow Vryckys Yfarngarrek",
  "block.minecraft.nether_brick_wall": "Fos Vryck Nether",
  "block.minecraft.nether_bricks": "Bryckys Nether",
  "block.minecraft.nether_gold_ore": "Moon Owr Nether",
  "block.minecraft.nether_portal": "Porth Nether",
  "block.minecraft.nether_quartz_ore": "Moon Kanndir Nether",
  "block.minecraft.nether_sprouts": "Kowligow Nether",
  "block.minecraft.nether_wart": "Losowen an Yfarn",
  "block.minecraft.nether_wart_block": "Stock Losow Nether",
  "block.minecraft.netherite_block": "Stock Netherit",
  "block.minecraft.netherrack": "Yfarngarrek",
  "block.minecraft.note_block": "Stock Noten",
  "block.minecraft.oak_button": "Boton Dar",
  "block.minecraft.oak_door": "Daras Dar",
  "block.minecraft.oak_fence": "Ke Dar",
  "block.minecraft.oak_fence_gate": "Yet Ke Dar",
  "block.minecraft.oak_hanging_sign": "Arwodh-Gregi Dar",
  "block.minecraft.oak_leaves": "Del Dar",
  "block.minecraft.oak_log": "Kyf Dar",
  "block.minecraft.oak_planks": "Estyl Dar",
  "block.minecraft.oak_pressure_plate": "Plat Gwaskedh Dar",
  "block.minecraft.oak_sapling": "Dar Yowynk",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Arwodh Dhar",
  "block.minecraft.oak_slab": "Leghen Dhar",
  "block.minecraft.oak_stairs": "Grisyow Dar",
  "block.minecraft.oak_trapdoor": "Lo an Jowl Dar",
  "block.minecraft.oak_wall_hanging_sign": "Arwodh-Gregi Fos Dar",
  "block.minecraft.oak_wall_sign": "Arwodh Fos Dar",
  "block.minecraft.oak_wood": "Prenn Dar",
  "block.minecraft.observer": "Mirer",
  "block.minecraft.obsidian": "Duweder",
  "block.minecraft.ochre_froglight": "Kwillugarn Meles",
  "block.minecraft.ominous_banner": "Baner Kolyek",
  "block.minecraft.open_eyeblossom": "Lagasvleujen Ygerys",
  "block.minecraft.orange_banner": "Baner Rudhvelyn",
  "block.minecraft.orange_bed": "Gweli Rudhvelyn",
  "block.minecraft.orange_candle": "Kantol Rudhvelyn",
  "block.minecraft.orange_candle_cake": "Tesen gans Kantol Rudhvelyn",
  "block.minecraft.orange_carpet": "Leurlen Rudhvelyn",
  "block.minecraft.orange_concrete": "Kestevyn Rudhvelyn",
  "block.minecraft.orange_concrete_powder": "Ponn Kestevyn Rudhvelyn",
  "block.minecraft.orange_glazed_terracotta": "Pri Pebys Gwedrys Rudhvelyn",
  "block.minecraft.orange_shulker_box": "Boks Shulker Rudhvelyn",
  "block.minecraft.orange_stained_glass": "Gweder Nammys Rudhvelyn",
  "block.minecraft.orange_stained_glass_pane": "Kwarel Nammys Rudhvelyn",
  "block.minecraft.orange_terracotta": "Pri Pebys Rudhvelyn",
  "block.minecraft.orange_tulip": "Tulyfant Rudhvelyn",
  "block.minecraft.orange_wool": "Gwlan Rudhvelyn",
  "block.minecraft.oxeye_daisy": "Kaja",
  "block.minecraft.oxidized_chiseled_copper": "Kober Gortewedhys Kervys",
  "block.minecraft.oxidized_copper": "Kober Gortewedhys",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Bollen Gober Gortewedhys",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Daras Kober Gortewedhys",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Maglen Kober Gortewedhys",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Lo an Jowl Kober Gortewedhys",
  "block.minecraft.oxidized_cut_copper": "Kober Treghys Gortewedhys",
  "block.minecraft.oxidized_cut_copper_slab": "Leghen Gober Treghys Gortewedhys",
  "block.minecraft.oxidized_cut_copper_stairs": "Grisyow Kober Treghys Gortewedhys",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Rew Kales",
  "block.minecraft.packed_mud": "Leys Gweskys",
  "block.minecraft.pale_hanging_moss": "Kewni-Kregi Disliw",
  "block.minecraft.pale_moss_block": "Stock Kewni Disliw",
  "block.minecraft.pale_moss_carpet": "Leurlen Gewni Disliw",
  "block.minecraft.pale_oak_button": "Boton Dar Disliw",
  "block.minecraft.pale_oak_door": "Daras Dar Disliw",
  "block.minecraft.pale_oak_fence": "Ke Dar Disliw",
  "block.minecraft.pale_oak_fence_gate": "Yet Ke Dar Disliw",
  "block.minecraft.pale_oak_hanging_sign": "Arwodh-Gregi Dar Disliw",
  "block.minecraft.pale_oak_leaves": "Del Dar Disliw",
  "block.minecraft.pale_oak_log": "Kyf Dar Disliw",
  "block.minecraft.pale_oak_planks": "Estyl Dar Disliw",
  "block.minecraft.pale_oak_pressure_plate": "Plat Gwaskedh Dar Disliw",
  "block.minecraft.pale_oak_sapling": "Gwydhen Yowynk Dar Disliw",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Arwodh Dhar Disliw",
  "block.minecraft.pale_oak_slab": "Leghen Dhar Disliw",
  "block.minecraft.pale_oak_stairs": "Grisyow Dar Disliw",
  "block.minecraft.pale_oak_trapdoor": "Lo an Jowl Dar Disliw",
  "block.minecraft.pale_oak_wall_hanging_sign": "Arwodh-Gregi Fos Dar Disliw",
  "block.minecraft.pale_oak_wall_sign": "Arwodh Fos Dar Disliw",
  "block.minecraft.pale_oak_wood": "Prenn Dar Disliw",
  "block.minecraft.pearlescent_froglight": "Kwillugarn Perlek",
  "block.minecraft.peony": "Rosen Venydh",
  "block.minecraft.petrified_oak_slab": "Leghen Dhar Menhes",
  "block.minecraft.piglin_head": "Penn Piglin",
  "block.minecraft.piglin_wall_head": "Penn Fos Piglin",
  "block.minecraft.pink_banner": "Baner Rudhwynn",
  "block.minecraft.pink_bed": "Gweli Gwynnrudh",
  "block.minecraft.pink_candle": "Kantol Rudhwynn",
  "block.minecraft.pink_candle_cake": "Tesen gans Kantol Rudhwyn",
  "block.minecraft.pink_carpet": "Leurlen Wynnrudh",
  "block.minecraft.pink_concrete": "Kestevyn Gwynnrudh",
  "block.minecraft.pink_concrete_powder": "Ponn Kestevyn Gwynnrudh",
  "block.minecraft.pink_glazed_terracotta": "Pri Pebys Gwedrys Rudhwynn",
  "block.minecraft.pink_petals": "Del Bleujen Rudhwyn",
  "block.minecraft.pink_shulker_box": "Boks Shulker Gwynnrudh",
  "block.minecraft.pink_stained_glass": "Gweder Nammys Gwynnrudh",
  "block.minecraft.pink_stained_glass_pane": "Kwarel Nammys Rudhwynn",
  "block.minecraft.pink_terracotta": "Pri Pebys Gwynnrudh",
  "block.minecraft.pink_tulip": "Tulyfant Gwynnrudh",
  "block.minecraft.pink_wool": "Gwlan Gwynnrudh",
  "block.minecraft.piston": "Pyston",
  "block.minecraft.piston_head": "Penn an Pyston",
  "block.minecraft.pitcher_crop": "Trevas Pycher",
  "block.minecraft.pitcher_plant": "Les Pycher",
  "block.minecraft.player_head": "Penn Gwarier",
  "block.minecraft.player_head.named": "Penn %s",
  "block.minecraft.player_wall_head": "Penn Gwarier Fos",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Men-Devera Bleynek",
  "block.minecraft.polished_andesite": "Andesit Bolsys",
  "block.minecraft.polished_andesite_slab": "Leghen Andesit Polsys",
  "block.minecraft.polished_andesite_stairs": "Grisyow Andesit Polsys",
  "block.minecraft.polished_basalt": "Pyllargarrek Bolsys",
  "block.minecraft.polished_blackstone": "Duven Polsys",
  "block.minecraft.polished_blackstone_brick_slab": "Leghen Vryck Duven Polsys",
  "block.minecraft.polished_blackstone_brick_stairs": "Grisyow Bryck Duven Polsys",
  "block.minecraft.polished_blackstone_brick_wall": "Fos Vryck Duven Polsys",
  "block.minecraft.polished_blackstone_bricks": "Bryckys Duven Polsys",
  "block.minecraft.polished_blackstone_button": "Boton Duven Polsys",
  "block.minecraft.polished_blackstone_pressure_plate": "Plat Gwaskedh Duven Polsys",
  "block.minecraft.polished_blackstone_slab": "Leghen Dhuven Polsys",
  "block.minecraft.polished_blackstone_stairs": "Grisyow Duven Polsys",
  "block.minecraft.polished_blackstone_wall": "Fos Dhuven Polsys",
  "block.minecraft.polished_deepslate": "Downgyllas Polsys",
  "block.minecraft.polished_deepslate_slab": "Leghen Dhowngyllas Polsys",
  "block.minecraft.polished_deepslate_stairs": "Grisyow Downgyllas Polsys",
  "block.minecraft.polished_deepslate_wall": "Fos Dhowngyllas Polsys",
  "block.minecraft.polished_diorite": "Diorit Bolsys",
  "block.minecraft.polished_diorite_slab": "Leghen Dhiorit Polsys",
  "block.minecraft.polished_diorite_stairs": "Grisyow Diorit Polsys",
  "block.minecraft.polished_granite": "Growan Polsys",
  "block.minecraft.polished_granite_slab": "Leghen Wrowan Polsys",
  "block.minecraft.polished_granite_stairs": "Grisyow Growan Polsys",
  "block.minecraft.polished_tuff": "Tuff Polsys",
  "block.minecraft.polished_tuff_slab": "Leghen Duff Polsys",
  "block.minecraft.polished_tuff_stairs": "Grisyow Tuff Polsys",
  "block.minecraft.polished_tuff_wall": "Fos Tuff Polsys",
  "block.minecraft.poppy": "Myll",
  "block.minecraft.potatoes": "Avalow Dor",
  "block.minecraft.potted_acacia_sapling": "Akasia Yowynk yn Pott",
  "block.minecraft.potted_allium": "Kenninen yn Pott",
  "block.minecraft.potted_azalea_bush": "Azalea yn Pott",
  "block.minecraft.potted_azure_bluet": "Arlodhesow Krener yn Pott",
  "block.minecraft.potted_bamboo": "Kors Eynda yn Pott",
  "block.minecraft.potted_birch_sapling": "Besow Yowynk yn Pott",
  "block.minecraft.potted_blue_orchid": "Tegyrinen Las yn Pott",
  "block.minecraft.potted_brown_mushroom": "Skavel Gronek Ell yn Pott",
  "block.minecraft.potted_cactus": "Kaktus yn Pott",
  "block.minecraft.potted_cherry_sapling": "Kereswydhen Yowynk yn Pott",
  "block.minecraft.potted_closed_eyeblossom": "Lagasvleujen Dheges yn Pott",
  "block.minecraft.potted_cornflower": "Glasik yn Pott",
  "block.minecraft.potted_crimson_fungus": "Fong Kogh yn Pott",
  "block.minecraft.potted_crimson_roots": "Gwreydh Kogh yn Pott",
  "block.minecraft.potted_dandelion": "Dans Lew yn Pott",
  "block.minecraft.potted_dark_oak_sapling": "Dar Tewal Yowynk yn Pott",
  "block.minecraft.potted_dead_bush": "Prysken Varow yn Pott",
  "block.minecraft.potted_fern": "Redenen yn Pott",
  "block.minecraft.potted_flowering_azalea_bush": "Azalea yn Pott ow Pleujyowa",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Gwedhen Gwylgos Yowynk yn Pott",
  "block.minecraft.potted_lily_of_the_valley": "Losow an Hav yn Pott",
  "block.minecraft.potted_mangrove_propagule": "Lesen Mangrof yn Pott",
  "block.minecraft.potted_oak_sapling": "Dar Yowynk yn Pott",
  "block.minecraft.potted_open_eyeblossom": "Lagasvleujen Ygerys yn Pott",
  "block.minecraft.potted_orange_tulip": "Tulyfant Rudhvelyn yn Pott",
  "block.minecraft.potted_oxeye_daisy": "Kaja yn Pott",
  "block.minecraft.potted_pale_oak_sapling": "Dar Disliw Yowynk yn Pott",
  "block.minecraft.potted_pink_tulip": "Tulyfant Rudhwynn yn Pott",
  "block.minecraft.potted_poppy": "Myll yn Pott",
  "block.minecraft.potted_red_mushroom": "Skavel Gronek Rudh yn Pott",
  "block.minecraft.potted_red_tulip": "Tulyfant Rudh yn Pott",
  "block.minecraft.potted_spruce_sapling": "Sprus Yowynk yn Pott",
  "block.minecraft.potted_torchflower": "Tanvleujen yn Pott",
  "block.minecraft.potted_warped_fungus": "Fong Koynt yn Pott",
  "block.minecraft.potted_warped_roots": "Gwreydh Koynt yn Pott",
  "block.minecraft.potted_white_tulip": "Tulyfant Wynn yn Pott",
  "block.minecraft.potted_wither_rose": "Ros Gwedhrek yn Pott",
  "block.minecraft.powder_snow": "Ergh Poltrus",
  "block.minecraft.powder_snow_cauldron": "Chek gans Ergh Poltrus",
  "block.minecraft.powered_rail": "Hyns Horn Tredanek",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Leghen Vryck Prismarin",
  "block.minecraft.prismarine_brick_stairs": "Grisyow Bryck Prismarin",
  "block.minecraft.prismarine_bricks": "Bryckys Prismarin",
  "block.minecraft.prismarine_slab": "Leghen Brismarin",
  "block.minecraft.prismarine_stairs": "Grisyow Prismarin",
  "block.minecraft.prismarine_wall": "Fos Prismarin",
  "block.minecraft.pumpkin": "Pompyon",
  "block.minecraft.pumpkin_stem": "Garen Bompyon",
  "block.minecraft.purple_banner": "Baner Purpur",
  "block.minecraft.purple_bed": "Gweli Purpur",
  "block.minecraft.purple_candle": "Kantol Burpur",
  "block.minecraft.purple_candle_cake": "Tesen gans Kantol Burpur",
  "block.minecraft.purple_carpet": "Leurlen Burpur",
  "block.minecraft.purple_concrete": "Kestevyn Purpur",
  "block.minecraft.purple_concrete_powder": "Ponn Kestevyn Purpur",
  "block.minecraft.purple_glazed_terracotta": "Pri Pebys Gwedrys Purpur",
  "block.minecraft.purple_shulker_box": "Boks Shulker Purpur",
  "block.minecraft.purple_stained_glass": "Gweder Nammys Purpur",
  "block.minecraft.purple_stained_glass_pane": "Kwarel Nammys Purpur",
  "block.minecraft.purple_terracotta": "Pri Pebys Purpur",
  "block.minecraft.purple_wool": "Gwlan Purpur",
  "block.minecraft.purpur_block": "Stock Purpur",
  "block.minecraft.purpur_pillar": "Koloven Burpur",
  "block.minecraft.purpur_slab": "Leghen Burpur",
  "block.minecraft.purpur_stairs": "Grisyow Purpur",
  "block.minecraft.quartz_block": "Stock Kanndir",
  "block.minecraft.quartz_bricks": "Bryckys Kanndir",
  "block.minecraft.quartz_pillar": "Koloven Ganndir",
  "block.minecraft.quartz_slab": "Leghen Ganndir",
  "block.minecraft.quartz_stairs": "Grisyow Kanndir",
  "block.minecraft.rail": "Hyns Horn",
  "block.minecraft.raw_copper_block": "Stock Kober Kriv",
  "block.minecraft.raw_gold_block": "Stock Owr Kriv",
  "block.minecraft.raw_iron_block": "Stock Horn Kriv",
  "block.minecraft.red_banner": "Baner Rudh",
  "block.minecraft.red_bed": "Gweli Rudh",
  "block.minecraft.red_candle": "Kantol Rudh",
  "block.minecraft.red_candle_cake": "Tesen gans Kantol Rudh",
  "block.minecraft.red_carpet": "Leurlen Rudh",
  "block.minecraft.red_concrete": "Kestevyn Rudh",
  "block.minecraft.red_concrete_powder": "Ponn Kestevyn Rudh",
  "block.minecraft.red_glazed_terracotta": "Pri Pebys Gwedrys Rudh",
  "block.minecraft.red_mushroom": "Skavel Gronek Rudh",
  "block.minecraft.red_mushroom_block": "Stock Skavel Gronek Rudh",
  "block.minecraft.red_nether_brick_slab": "Leghen Bryck Nether Rudh",
  "block.minecraft.red_nether_brick_stairs": "Grisyow Bryck Nether Rudh",
  "block.minecraft.red_nether_brick_wall": "Fos Vryck Nether Rudh",
  "block.minecraft.red_nether_bricks": "Bryckys Nether Rudh",
  "block.minecraft.red_sand": "Tewes Rudh",
  "block.minecraft.red_sandstone": "Krag Rudh",
  "block.minecraft.red_sandstone_slab": "Leghen Grag Rudh",
  "block.minecraft.red_sandstone_stairs": "Grisyow Krag Rudh",
  "block.minecraft.red_sandstone_wall": "Fos Krag Rudh",
  "block.minecraft.red_shulker_box": "Boks Shulker Rudh",
  "block.minecraft.red_stained_glass": "Gweder Nammys Rudh",
  "block.minecraft.red_stained_glass_pane": "Kwarel Nammys Rudh",
  "block.minecraft.red_terracotta": "Pri Pebys Rudh",
  "block.minecraft.red_tulip": "Tulyfant Rudh",
  "block.minecraft.red_wool": "Gwlan Rudh",
  "block.minecraft.redstone_block": "Stock Rudhven",
  "block.minecraft.redstone_lamp": "Lugarn Rudhven",
  "block.minecraft.redstone_ore": "Moon Rudhven",
  "block.minecraft.redstone_torch": "Faglen Rudhven",
  "block.minecraft.redstone_wall_torch": "Faglen Fos Rudhven",
  "block.minecraft.redstone_wire": "Gwivren Rudhven",
  "block.minecraft.reinforced_deepslate": "Downgyllas Krefhes",
  "block.minecraft.repeater": "Daswrier Rudhven",
  "block.minecraft.repeating_command_block": "Stock Gorhemmyn Daswul",
  "block.minecraft.resin_block": "Stock Rosin",
  "block.minecraft.resin_brick_slab": "Leghen Vryck Rosin",
  "block.minecraft.resin_brick_stairs": "Grisyow Bryck Rosin",
  "block.minecraft.resin_brick_wall": "Fos Vryck Rosin",
  "block.minecraft.resin_bricks": "Bryckys Rosin",
  "block.minecraft.resin_clump": "Rann Rosin",
  "block.minecraft.respawn_anchor": "Ankor Dasserghi",
  "block.minecraft.rooted_dirt": "Dor gans Gwreydh",
  "block.minecraft.rose_bush": "Prysken Ros",
  "block.minecraft.sand": "Tewes",
  "block.minecraft.sandstone": "Krag",
  "block.minecraft.sandstone_slab": "Leghen Grag",
  "block.minecraft.sandstone_stairs": "Grisyow Krag",
  "block.minecraft.sandstone_wall": "Fos Krag",
  "block.minecraft.scaffolding": "Mynk",
  "block.minecraft.sculk": "Skulk",
  "block.minecraft.sculk_catalyst": "Katalyth Skulk",
  "block.minecraft.sculk_sensor": "Sensour Skulk",
  "block.minecraft.sculk_shrieker": "Skrijer Skulk",
  "block.minecraft.sculk_vein": "Skorren Skulk",
  "block.minecraft.sea_lantern": "Lugarn an Mor",
  "block.minecraft.sea_pickle": "Pyckel Mor",
  "block.minecraft.seagrass": "Gwels Mor",
  "block.minecraft.set_spawn": "Poynt dasserghi a veu settys",
  "block.minecraft.short_dry_grass": "Gwels Berr Sygh",
  "block.minecraft.short_grass": "Gwels Berr",
  "block.minecraft.shroomlight": "Fonglugarn",
  "block.minecraft.shulker_box": "Boks Shulker",
  "block.minecraft.skeleton_skull": "Klopen",
  "block.minecraft.skeleton_wall_skull": "Klopen Fos",
  "block.minecraft.slime_block": "Stock Slim",
  "block.minecraft.small_amethyst_bud": "Egyn Amethyst Byghan",
  "block.minecraft.small_dripleaf": "Delen-Dhevera Byghan",
  "block.minecraft.smithing_table": "Moos Gov",
  "block.minecraft.smoker": "Megell",
  "block.minecraft.smooth_basalt": "Pyllargarrek Smodh",
  "block.minecraft.smooth_quartz": "Stock Kanndir Smodh",
  "block.minecraft.smooth_quartz_slab": "Leghen Ganndir Smodh",
  "block.minecraft.smooth_quartz_stairs": "Grisyow Kanndir Smodh",
  "block.minecraft.smooth_red_sandstone": "Krag Rudh Smodh",
  "block.minecraft.smooth_red_sandstone_slab": "Leghen Grag Rudh Smodh",
  "block.minecraft.smooth_red_sandstone_stairs": "Grisyow Krag Rudh Smodh",
  "block.minecraft.smooth_sandstone": "Krag Smodh",
  "block.minecraft.smooth_sandstone_slab": "Leghen Grag Smodh",
  "block.minecraft.smooth_sandstone_stairs": "Grisyow Krag Smodh",
  "block.minecraft.smooth_stone": "Men Smodh",
  "block.minecraft.smooth_stone_slab": "Leghen Ven Smodh",
  "block.minecraft.sniffer_egg": "Oy Frikhwyther",
  "block.minecraft.snow": "Ergh",
  "block.minecraft.snow_block": "Stock Ergh",
  "block.minecraft.soul_campfire": "Tan Kamp Enev",
  "block.minecraft.soul_fire": "Tan Enev",
  "block.minecraft.soul_lantern": "Lugarn Enev",
  "block.minecraft.soul_sand": "Tewes Enev",
  "block.minecraft.soul_soil": "Dor Enev",
  "block.minecraft.soul_torch": "Faglen Enev",
  "block.minecraft.soul_wall_torch": "Faglen Enev Fos",
  "block.minecraft.spawn.not_valid": "Nyns eus gweli tre po ankor dasserghi kargys dhis, po yth yw lettys",
  "block.minecraft.spawner": "Bewheor Tebelvestes",
  "block.minecraft.spawner.desc1": "Ynterweythresa gans Oy Bewhe:",
  "block.minecraft.spawner.desc2": "Y sett eghen an mob",
  "block.minecraft.sponge": "Spong",
  "block.minecraft.spore_blossom": "Bleujen Spor",
  "block.minecraft.spruce_button": "Boton Sprus",
  "block.minecraft.spruce_door": "Daras Sprus",
  "block.minecraft.spruce_fence": "Ke Sprus",
  "block.minecraft.spruce_fence_gate": "Yet Ke Sprus",
  "block.minecraft.spruce_hanging_sign": "Arwodh-Gregi Sprus",
  "block.minecraft.spruce_leaves": "Del Sprus",
  "block.minecraft.spruce_log": "Kyf Sprus",
  "block.minecraft.spruce_planks": "Estyl Sprus",
  "block.minecraft.spruce_pressure_plate": "Plat Gwaskedh Sprus",
  "block.minecraft.spruce_sapling": "Sprus Yowynk",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Arwodh Sprus",
  "block.minecraft.spruce_slab": "Leghen Sprus",
  "block.minecraft.spruce_stairs": "Grisyow Sprus",
  "block.minecraft.spruce_trapdoor": "Lo an Jowl Sprus",
  "block.minecraft.spruce_wall_hanging_sign": "Arwodh-Gregi Fos Sprus",
  "block.minecraft.spruce_wall_sign": "Arwodh Fos Sprus",
  "block.minecraft.spruce_wood": "Prenn Sprus",
  "block.minecraft.sticky_piston": "Pyston Glusek",
  "block.minecraft.stone": "Men",
  "block.minecraft.stone_brick_slab": "Leghen Vryck Men",
  "block.minecraft.stone_brick_stairs": "Grisyow Bryck Men",
  "block.minecraft.stone_brick_wall": "Fos Vryck Men",
  "block.minecraft.stone_bricks": "Bryckys Men",
  "block.minecraft.stone_button": "Boton Men",
  "block.minecraft.stone_pressure_plate": "Plat Gwaskedh Men",
  "block.minecraft.stone_slab": "Leghen Ven",
  "block.minecraft.stone_stairs": "Grisyow Men",
  "block.minecraft.stonecutter": "Treghell Ven",
  "block.minecraft.stripped_acacia_log": "Kyf Akasia Lommhes",
  "block.minecraft.stripped_acacia_wood": "Prenn Akasia Lommhes",
  "block.minecraft.stripped_bamboo_block": "Stock Kors Eynda Lommhes",
  "block.minecraft.stripped_birch_log": "Kyf Besow Lommhes",
  "block.minecraft.stripped_birch_wood": "Prenn Besow Lommhes",
  "block.minecraft.stripped_cherry_log": "Kyf Kereswydh Lommhes",
  "block.minecraft.stripped_cherry_wood": "Prenn Kereswydh Lommhes",
  "block.minecraft.stripped_crimson_hyphae": "Trethow Kogh Lommhes",
  "block.minecraft.stripped_crimson_stem": "Garen Gogh Lommhes",
  "block.minecraft.stripped_dark_oak_log": "Kyf Dar Tewal Lommhes",
  "block.minecraft.stripped_dark_oak_wood": "Prenn Dar Tewal Lommhes",
  "block.minecraft.stripped_jungle_log": "Kyf Gwylgos Lommhes",
  "block.minecraft.stripped_jungle_wood": "Prenn Gwylgos Lommhes",
  "block.minecraft.stripped_mangrove_log": "Kyf Mangrof Lommhes",
  "block.minecraft.stripped_mangrove_wood": "Prenn Mangrof Lommhes",
  "block.minecraft.stripped_oak_log": "Kyf Dar Lommhes",
  "block.minecraft.stripped_oak_wood": "Prenn Dar Lommhes",
  "block.minecraft.stripped_pale_oak_log": "Kyf Dar Disliw Lommhes",
  "block.minecraft.stripped_pale_oak_wood": "Prenn Dar Disliw Lommhes",
  "block.minecraft.stripped_spruce_log": "Kyf Sprus Lommhes",
  "block.minecraft.stripped_spruce_wood": "Prenn Sprus Lommhes",
  "block.minecraft.stripped_warped_hyphae": "Trethow Koynt Lommhes",
  "block.minecraft.stripped_warped_stem": "Garen Goynt Lommhes",
  "block.minecraft.structure_block": "Stock Strethur",
  "block.minecraft.structure_void": "Gwagle Strethur",
  "block.minecraft.sugar_cane": "Gwelen Sugra",
  "block.minecraft.sunflower": "Bleujen an Howl",
  "block.minecraft.suspicious_gravel": "Grow Skeusek",
  "block.minecraft.suspicious_sand": "Tewes Skeusek",
  "block.minecraft.sweet_berry_bush": "Prysken Voren Hweg",
  "block.minecraft.tall_dry_grass": "Gwels Hir Sygh",
  "block.minecraft.tall_grass": "Gwels Hir",
  "block.minecraft.tall_seagrass": "Gwels Mor Hir",
  "block.minecraft.target": "Kosten",
  "block.minecraft.terracotta": "Pri Pebys",
  "block.minecraft.test_block": "Stock Prov",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Gweder Arliwys",
  "block.minecraft.tnt": "Dynamit",
  "block.minecraft.tnt.disabled": "Tardhow TNT yw diallosegys",
  "block.minecraft.torch": "Faglen",
  "block.minecraft.torchflower": "Tanvleujen",
  "block.minecraft.torchflower_crop": "Trevas Tanvleujen",
  "block.minecraft.trapped_chest": "Kist gans Maglen",
  "block.minecraft.trial_spawner": "Bewher Prov",
  "block.minecraft.tripwire": "Gwivren",
  "block.minecraft.tripwire_hook": "Higen rag Gwivren",
  "block.minecraft.tube_coral": "Korel Piben",
  "block.minecraft.tube_coral_block": "Stock Korel Piben",
  "block.minecraft.tube_coral_fan": "Fan Korel Piben",
  "block.minecraft.tube_coral_wall_fan": "Fan Fos Korel Piben",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Leghen Vryckys Tuff",
  "block.minecraft.tuff_brick_stairs": "Grisyow Bryckys Tuff",
  "block.minecraft.tuff_brick_wall": "Fos Vryckys Tuff",
  "block.minecraft.tuff_bricks": "Bryckys Tuff",
  "block.minecraft.tuff_slab": "Leghen Duff",
  "block.minecraft.tuff_stairs": "Grisyow Tuff",
  "block.minecraft.tuff_wall": "Fos Tuff",
  "block.minecraft.turtle_egg": "Oy Morgroban",
  "block.minecraft.twisting_vines": "Gwinbrennyer Nedha",
  "block.minecraft.twisting_vines_plant": "Plans Gwinbrennyer Nedha",
  "block.minecraft.vault": "Argh",
  "block.minecraft.verdant_froglight": "Kwillugarn Glas",
  "block.minecraft.vine": "Gwinbrennyer",
  "block.minecraft.void_air": "Ayr Efanvos",
  "block.minecraft.wall_torch": "Faglen Fos",
  "block.minecraft.warped_button": "Boton Koynt",
  "block.minecraft.warped_door": "Daras Koynt",
  "block.minecraft.warped_fence": "Ke Koynt",
  "block.minecraft.warped_fence_gate": "Yet Ke Koynt",
  "block.minecraft.warped_fungus": "Fong Koynt",
  "block.minecraft.warped_hanging_sign": "Arwodh-Gregi Koynt",
  "block.minecraft.warped_hyphae": "Trethow Koynt",
  "block.minecraft.warped_nylium": "Nylium Koynt",
  "block.minecraft.warped_planks": "Estyl Koynt",
  "block.minecraft.warped_pressure_plate": "Plat Gwaskedh Koynt",
  "block.minecraft.warped_roots": "Gwreydh Koynt",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Arwodh Koynt",
  "block.minecraft.warped_slab": "Leghen Goynt",
  "block.minecraft.warped_stairs": "Grisyow Koynt",
  "block.minecraft.warped_stem": "Garen Goynt",
  "block.minecraft.warped_trapdoor": "Lo an Jowl Koynt",
  "block.minecraft.warped_wall_hanging_sign": "Arwodh-Gregi Fos Koynt",
  "block.minecraft.warped_wall_sign": "Arwodh Fos Koynt",
  "block.minecraft.warped_wart_block": "Stock Losow Koynt",
  "block.minecraft.water": "Dowr",
  "block.minecraft.water_cauldron": "Chek Dowr",
  "block.minecraft.waxed_chiseled_copper": "Kober Korys Kervys",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Stock Kober Korys",
  "block.minecraft.waxed_copper_bulb": "Bollen Gober Korys",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Daras Kober Korys",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Maglen Gober Korys",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Lo an Jowl Kober Korys",
  "block.minecraft.waxed_cut_copper": "Kober Treghys Korys",
  "block.minecraft.waxed_cut_copper_slab": "Leghen Gober Treghys Korys",
  "block.minecraft.waxed_cut_copper_stairs": "Grisyow Kober Treghys Korys",
  "block.minecraft.waxed_exposed_chiseled_copper": "Kober Korys Godewedhys Kervys",
  "block.minecraft.waxed_exposed_copper": "Kober Korys Godewedhys",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Bollen Gober Korys Godewedhys",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Daras Kober Korys Godewedhys",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Maglen Gober Korys Godewedhys",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Lo an Jowl Kober Korys Godewedhys",
  "block.minecraft.waxed_exposed_cut_copper": "Kober Korys Treghys Godewedhys",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Leghen Gober Korys Treghys Godewedhys",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Grisyow Kober Korys Treghys Godewedhys",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Kober Korys Gortewedhys Kervys",
  "block.minecraft.waxed_oxidized_copper": "Kober Korys Oksidisys",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Bollen Gober Korys Gortewedhys Kervys",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Daras Kober Korys Gortewedhys Kervys",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Maglen Gober Korys Gortewedhys",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Lo an Jowl Kober Korys Gortewedhys Kervys",
  "block.minecraft.waxed_oxidized_cut_copper": "Kober Korys Treghys Oksidisys",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Leghen Gober Korys Treghys Oksidisys",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Grisyow Kober Korys Treghys Oksidisys",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Kober Korys Tewedhys Kervys",
  "block.minecraft.waxed_weathered_copper": "Kober Korys Tewedhys",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Bollen Gober Korys Tewedhys",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Daras Kober Korys Tewedhys",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Maglen Gober Korys Tewedhys",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Lo an Jowl Kober Korys Tewedhys",
  "block.minecraft.waxed_weathered_cut_copper": "Kober Korys Treghys Tewedhys",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Leghen Gober Treghys Korys Tewedhys",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Grisyow Kober Treghys Korys Tewedhys",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Lo an Jowl Kober Korys Tewedhys",
  "block.minecraft.weathered_copper": "Kober Tewedhys",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Bollen Gober Tewedhys",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Daras Kober Tewedhys",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Maglen Gober Tewedhys",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Lo an Jowl Kober Tewedhys",
  "block.minecraft.weathered_cut_copper": "Kober Treghys Tewedhys",
  "block.minecraft.weathered_cut_copper_slab": "Leghen Gober Treghys Tewedhys",
  "block.minecraft.weathered_cut_copper_stairs": "Grisyow Kober Treghys Tewedhys",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Gwinbrennyer Ola",
  "block.minecraft.weeping_vines_plant": "Plans Gwinbrennyer Ola",
  "block.minecraft.wet_sponge": "Spong Glyb",
  "block.minecraft.wheat": "Trevasow Gwaneth",
  "block.minecraft.white_banner": "Baner Gwynn",
  "block.minecraft.white_bed": "Gweli Gwynn",
  "block.minecraft.white_candle": "Kantol Wynn",
  "block.minecraft.white_candle_cake": "Tesen gans Kantol Wynn",
  "block.minecraft.white_carpet": "Leurlen Wynn",
  "block.minecraft.white_concrete": "Kestevyn Gwynn",
  "block.minecraft.white_concrete_powder": "Ponn Kestevyn Gwynn",
  "block.minecraft.white_glazed_terracotta": "Pri Pebys Gwedrys Gwynn",
  "block.minecraft.white_shulker_box": "Boks Shulker Gwynn",
  "block.minecraft.white_stained_glass": "Gweder Nammys Gwynn",
  "block.minecraft.white_stained_glass_pane": "Kwarel Nammys Gwynn",
  "block.minecraft.white_terracotta": "Pri Pebys Gwynn",
  "block.minecraft.white_tulip": "Tulyfant Gwynn",
  "block.minecraft.white_wool": "Gwlan Gwynn",
  "block.minecraft.wildflowers": "Bleujyow Gwyls",
  "block.minecraft.wither_rose": "Rosyn Gwedhrek",
  "block.minecraft.wither_skeleton_skull": "Klopen Gwedhrek",
  "block.minecraft.wither_skeleton_wall_skull": "Klopen Gwedhrek Fos",
  "block.minecraft.yellow_banner": "Baner Melyn",
  "block.minecraft.yellow_bed": "Gweli Melyn",
  "block.minecraft.yellow_candle": "Kantol Velyn",
  "block.minecraft.yellow_candle_cake": "Tesen gans Kantol Velyn",
  "block.minecraft.yellow_carpet": "Leurlen Velyn",
  "block.minecraft.yellow_concrete": "Kestevyn Melyn",
  "block.minecraft.yellow_concrete_powder": "Ponn Kestevyn Melyn",
  "block.minecraft.yellow_glazed_terracotta": "Pri Pebys Gwedrys Melyn",
  "block.minecraft.yellow_shulker_box": "Boks Shulker Melyn",
  "block.minecraft.yellow_stained_glass": "Gweder Nammys Melyn",
  "block.minecraft.yellow_stained_glass_pane": "Kwarel Nammys Melyn",
  "block.minecraft.yellow_terracotta": "Pri Pebys Melyn",
  "block.minecraft.yellow_wool": "Gwlan Melyn",
  "block.minecraft.zombie_head": "Penn Zombi",
  "block.minecraft.zombie_wall_head": "Penn Fos Zombi",
  "item.minecraft.acacia_boat": "Skath Akasia",
  "item.minecraft.acacia_chest_boat": "Skath Akasia gans Kist",
  "item.minecraft.allay_spawn_egg": "Oy Bewhe Fay",
  "item.minecraft.amethyst_shard": "Darn Amethyst",
  "item.minecraft.angler_pottery_shard": "Darn Pott Pyskador",
  "item.minecraft.angler_pottery_sherd": "Darn Pott Pyskador",
  "item.minecraft.apple": "Aval",
  "item.minecraft.archer_pottery_shard": "Darn Pott Sether",
  "item.minecraft.archer_pottery_sherd": "Darn Pott Sether",
  "item.minecraft.armadillo_scute": "Skansen Arvegyn",
  "item.minecraft.armadillo_spawn_egg": "Oy Bewhe Arvegyn",
  "item.minecraft.armor_stand": "Stand Arvwisk",
  "item.minecraft.arms_up_pottery_shard": "Darn Pott Diwvregh Yn-Bann",
  "item.minecraft.arms_up_pottery_sherd": "Darn Pott Diwvregh Yn-Bann",
  "item.minecraft.arrow": "Seth",
  "item.minecraft.axolotl_bucket": "Kelorn Asholotl",
  "item.minecraft.axolotl_spawn_egg": "Oy Bewhe Asholotl",
  "item.minecraft.baked_potato": "Aval Dor Pebys",
  "item.minecraft.bamboo_chest_raft": "Skath Klos Kors Eynda gans Kist",
  "item.minecraft.bamboo_raft": "Skath Klos Kors Eynda",
  "item.minecraft.bat_spawn_egg": "Oy Bewhe Askel Groghen",
  "item.minecraft.bee_spawn_egg": "Oy Bewhe Gwenenen",
  "item.minecraft.beef": "Kig Bewin Kriv",
  "item.minecraft.beetroot": "Betysen Rudh",
  "item.minecraft.beetroot_seeds": "Has Betys Rudh",
  "item.minecraft.beetroot_soup": "Kowl Betys",
  "item.minecraft.birch_boat": "Skath Vesow",
  "item.minecraft.birch_chest_boat": "Skath Vesow gans Kist",
  "item.minecraft.black_bundle": "Pusorn Du",
  "item.minecraft.black_dye": "Liw Du",
  "item.minecraft.black_harness": "Hernes Du",
  "item.minecraft.blade_pottery_shard": "Darn Pott Lown",
  "item.minecraft.blade_pottery_sherd": "Darn Pott Lown",
  "item.minecraft.blaze_powder": "Ponn Tan",
  "item.minecraft.blaze_rod": "Gwelen Dan",
  "item.minecraft.blaze_spawn_egg": "Oy Bewhe Tarosvan Tan",
  "item.minecraft.blue_bundle": "Pusorn Glas",
  "item.minecraft.blue_dye": "Liw Glas",
  "item.minecraft.blue_egg": "Oy Glas",
  "item.minecraft.blue_harness": "Hernes Glas",
  "item.minecraft.bogged_spawn_egg": "Oy Bewhe Kors Eskern",
  "item.minecraft.bolt_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Taklans Arvwisk Ebil",
  "item.minecraft.bone": "Askorn",
  "item.minecraft.bone_meal": "Ponn Askorn",
  "item.minecraft.book": "Lyver",
  "item.minecraft.bordure_indented_banner_pattern": "Patron Baner Amal Kribys",
  "item.minecraft.bow": "Gwarek",
  "item.minecraft.bowl": "Bolla",
  "item.minecraft.bread": "Bara",
  "item.minecraft.breeze_rod": "Gwelen Awel Glor",
  "item.minecraft.breeze_spawn_egg": "Oy Bewhe Awel Glor",
  "item.minecraft.brewer_pottery_shard": "Darn Pott Brager",
  "item.minecraft.brewer_pottery_sherd": "Darn Pott Brager",
  "item.minecraft.brewing_stand": "Sav Braga",
  "item.minecraft.brick": "Bryck",
  "item.minecraft.brown_bundle": "Pusorn Gell",
  "item.minecraft.brown_dye": "Liw Gell",
  "item.minecraft.brown_egg": "Oy Gell",
  "item.minecraft.brown_harness": "Hernes Gell",
  "item.minecraft.brush": "Skubell",
  "item.minecraft.bucket": "Kelorn",
  "item.minecraft.bundle": "Pusorn",
  "item.minecraft.bundle.empty": "Gwag",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Leun",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Darn Pott Losk",
  "item.minecraft.burn_pottery_sherd": "Darn Pott Losk",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Oy Bewhe Kowrvargh",
  "item.minecraft.carrot": "Karetysen",
  "item.minecraft.carrot_on_a_stick": "Karetysen war Gwelen",
  "item.minecraft.cat_spawn_egg": "Oy Bewhe Kath",
  "item.minecraft.cauldron": "Kawdarn",
  "item.minecraft.cave_spider_spawn_egg": "Oy Bewhe Kevnisen Gav",
  "item.minecraft.chainmail_boots": "Botas Chayn",
  "item.minecraft.chainmail_chestplate": "Lurik Chayn",
  "item.minecraft.chainmail_helmet": "Basnet Chayn",
  "item.minecraft.chainmail_leggings": "Lavrek Chayn",
  "item.minecraft.charcoal": "Glowbren",
  "item.minecraft.cherry_boat": "Skath Kereswydh",
  "item.minecraft.cherry_chest_boat": "Skath Kereswydh gans Kist",
  "item.minecraft.chest_minecart": "Balgert gans Kist",
  "item.minecraft.chicken": "Kig Yar Kriv",
  "item.minecraft.chicken_spawn_egg": "Oy Bewhe Yar",
  "item.minecraft.chorus_fruit": "Frothen Goros",
  "item.minecraft.clay_ball": "Pel Bri",
  "item.minecraft.clock": "Klock",
  "item.minecraft.coal": "Glow",
  "item.minecraft.coast_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Taklans Arvwisk Arvor",
  "item.minecraft.cocoa_beans": "Fav Kokoa",
  "item.minecraft.cod": "Barvus Kriv",
  "item.minecraft.cod_bucket": "Kelorn Barvus",
  "item.minecraft.cod_spawn_egg": "Oy Bewhe Barvus",
  "item.minecraft.command_block_minecart": "Balgert gans Stock Gorhemmyn",
  "item.minecraft.compass": "Mornaswydh",
  "item.minecraft.cooked_beef": "Tregh Kig",
  "item.minecraft.cooked_chicken": "Kig Yar Keginys",
  "item.minecraft.cooked_cod": "Barvus Keginys",
  "item.minecraft.cooked_mutton": "Kig Mols Keginys",
  "item.minecraft.cooked_porkchop": "Kig Mogh Keginys",
  "item.minecraft.cooked_rabbit": "Kig Konin Keginys",
  "item.minecraft.cooked_salmon": "Eghek Keginys",
  "item.minecraft.cookie": "Tesen Gales",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Etewik Kober",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Tamm Kober",
  "item.minecraft.copper_pickaxe": "Pigell Gober",
  "item.minecraft.copper_shovel": "Reuv Gober",
  "item.minecraft.copper_spear": "Guw Kober",
  "item.minecraft.copper_sword": "Kledha Kober",
  "item.minecraft.cow_spawn_egg": "Oy Bewhe Bugh",
  "item.minecraft.creaking_spawn_egg": "Oy Bewhe Gwighal",
  "item.minecraft.creeper_banner_pattern": "Patron Baner",
  "item.minecraft.creeper_banner_pattern.desc": "Arwodh Kreeper",
  "item.minecraft.creeper_banner_pattern.new": "Patron Baner Arwodh Kreeper",
  "item.minecraft.creeper_spawn_egg": "Oy Bewhe Kreeper",
  "item.minecraft.crossbow": "Fustwarak",
  "item.minecraft.crossbow.projectile": "Towlyn:",
  "item.minecraft.crossbow.projectile.multiple": "Towlyn: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Towlyn: %s",
  "item.minecraft.cyan_bundle": "Pusorn Glaswyrdh",
  "item.minecraft.cyan_dye": "Liw Glaswyrdh",
  "item.minecraft.cyan_harness": "Hernes Glaswyrdh",
  "item.minecraft.danger_pottery_shard": "Darn Pott Peryl",
  "item.minecraft.danger_pottery_sherd": "Darn Pott Peryl",
  "item.minecraft.dark_oak_boat": "Skath Dhar Tewal",
  "item.minecraft.dark_oak_chest_boat": "Skath Dhar Tewal gans Kist",
  "item.minecraft.debug_stick": "Gwelen Dhibryv",
  "item.minecraft.debug_stick.empty": "Nyns eus gnas dhe %s",
  "item.minecraft.debug_stick.select": "\"%s\" (%s) dewisys",
  "item.minecraft.debug_stick.update": "\"%s\" dhe %s",
  "item.minecraft.diamond": "Adamant",
  "item.minecraft.diamond_axe": "Bool Adamant",
  "item.minecraft.diamond_boots": "Botas Adamant",
  "item.minecraft.diamond_chestplate": "Lurik Adamant",
  "item.minecraft.diamond_helmet": "Basnet Adamant",
  "item.minecraft.diamond_hoe": "Kravell Adamant",
  "item.minecraft.diamond_horse_armor": "Arvwisk Margh Adamant",
  "item.minecraft.diamond_leggings": "Lavrek Adamant",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Pigell Adamant",
  "item.minecraft.diamond_shovel": "Pal Adamant",
  "item.minecraft.diamond_spear": "Guw Adamant",
  "item.minecraft.diamond_sword": "Kledha Adamant",
  "item.minecraft.disc_fragment_5": "Tamm Plasen",
  "item.minecraft.disc_fragment_5.desc": "Plasen Ilow - 5",
  "item.minecraft.dolphin_spawn_egg": "Oy Bewhe Pyffyer",
  "item.minecraft.donkey_spawn_egg": "Oy Bewhe Asen",
  "item.minecraft.dragon_breath": "Anal an Dhragon",
  "item.minecraft.dried_kelp": "Gommon Seghys",
  "item.minecraft.drowned_spawn_egg": "Oy Bewhe Zombi Beudhys",
  "item.minecraft.dune_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Taklans Arvwisk Tewyn",
  "item.minecraft.echo_shard": "Darn Dasson",
  "item.minecraft.egg": "Oy",
  "item.minecraft.elder_guardian_spawn_egg": "Oy Bewhe Gwithyas Koth",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Gwerem",
  "item.minecraft.enchanted_book": "Lyver gans Hus",
  "item.minecraft.enchanted_golden_apple": "Aval Owr gans Hus",
  "item.minecraft.end_crystal": "Gwrys an Diwedh",
  "item.minecraft.ender_dragon_spawn_egg": "Oy Bewhe Dragon an Diwedh",
  "item.minecraft.ender_eye": "Lagas Den an Diwedh",
  "item.minecraft.ender_pearl": "Perl an Diwedh",
  "item.minecraft.enderman_spawn_egg": "Oy Bewhe Den an Diwedh",
  "item.minecraft.endermite_spawn_egg": "Oy Bewhe Endermite",
  "item.minecraft.evoker_spawn_egg": "Oy Bewhe Sordyer",
  "item.minecraft.experience_bottle": "Botel a Hus",
  "item.minecraft.explorer_pottery_shard": "Darn Priweyth Hwithrer Tiryow",
  "item.minecraft.explorer_pottery_sherd": "Darn Priweyth Hwithrer Tiryow",
  "item.minecraft.eye_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Taklans Arvwisk Lagas",
  "item.minecraft.feather": "Pluven",
  "item.minecraft.fermented_spider_eye": "Lagas Kevnisen Bryghys",
  "item.minecraft.field_masoned_banner_pattern": "Patron Baner Bryckys",
  "item.minecraft.filled_map": "Mappa",
  "item.minecraft.fire_charge": "Diskargans Tan",
  "item.minecraft.firework_rocket": "Fusen Danweythen",
  "item.minecraft.firework_rocket.flight": "Hirder an Neyj:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Steren Tanweyth",
  "item.minecraft.firework_star.black": "Du",
  "item.minecraft.firework_star.blue": "Glas",
  "item.minecraft.firework_star.brown": "Gell",
  "item.minecraft.firework_star.custom_color": "A-vusur",
  "item.minecraft.firework_star.cyan": "Glaswyrdh",
  "item.minecraft.firework_star.fade_to": "Disliwa dhe",
  "item.minecraft.firework_star.flicker": "Terlentri",
  "item.minecraft.firework_star.gray": "Loos",
  "item.minecraft.firework_star.green": "Gwyrdh",
  "item.minecraft.firework_star.light_blue": "Glaswynn",
  "item.minecraft.firework_star.light_gray": "Gwynnloos",
  "item.minecraft.firework_star.lime": "Gwynnwyrdh",
  "item.minecraft.firework_star.magenta": "Majenta",
  "item.minecraft.firework_star.orange": "Rudhvelyn",
  "item.minecraft.firework_star.pink": "Rudhwynn",
  "item.minecraft.firework_star.purple": "Purpur",
  "item.minecraft.firework_star.red": "Rudh",
  "item.minecraft.firework_star.shape": "Roth Ankoth",
  "item.minecraft.firework_star.shape.burst": "Tardh",
  "item.minecraft.firework_star.shape.creeper": "Shap Kreeper",
  "item.minecraft.firework_star.shape.large_ball": "Pel Vras",
  "item.minecraft.firework_star.shape.small_ball": "Pel Vyghan",
  "item.minecraft.firework_star.shape.star": "Shap Steren",
  "item.minecraft.firework_star.trail": "Lergh",
  "item.minecraft.firework_star.white": "Gwynn",
  "item.minecraft.firework_star.yellow": "Melyn",
  "item.minecraft.fishing_rod": "Gwelen-Byskessa",
  "item.minecraft.flint": "Kelester",
  "item.minecraft.flint_and_steel": "Kelester ha Dur",
  "item.minecraft.flow_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Taklans Arvwisk Fros",
  "item.minecraft.flow_banner_pattern": "Patron Baner",
  "item.minecraft.flow_banner_pattern.desc": "Fros",
  "item.minecraft.flow_banner_pattern.new": "Patron Baner Fros",
  "item.minecraft.flow_pottery_sherd": "Darn Priweyth Fros",
  "item.minecraft.flower_banner_pattern": "Patron Baner",
  "item.minecraft.flower_banner_pattern.desc": "Arwodh Bleujen",
  "item.minecraft.flower_banner_pattern.new": "Patron Baner Bleujen",
  "item.minecraft.flower_pot": "Pott",
  "item.minecraft.fox_spawn_egg": "Oy Bewhe Lowarn",
  "item.minecraft.friend_pottery_shard": "Darn Pott Koweth",
  "item.minecraft.friend_pottery_sherd": "Darn Pott Koweth",
  "item.minecraft.frog_spawn_egg": "Oy Bewhe Kwilkyn",
  "item.minecraft.furnace_minecart": "Balkert gans Fog",
  "item.minecraft.ghast_spawn_egg": "Oy Bewhe Tarosvan",
  "item.minecraft.ghast_tear": "Dager Tarosvan",
  "item.minecraft.glass_bottle": "Botel Gweder",
  "item.minecraft.glistering_melon_slice": "Tregh Pompyon Hweg Splann",
  "item.minecraft.globe_banner_pattern": "Patron Baner",
  "item.minecraft.globe_banner_pattern.desc": "Pel An Norvys",
  "item.minecraft.globe_banner_pattern.new": "Patron Baner Pel an Norvys",
  "item.minecraft.glow_berries": "Moren-Splanna",
  "item.minecraft.glow_ink_sac": "Sagh Ynk-Splanna",
  "item.minecraft.glow_item_frame": "Fram-Splanna",
  "item.minecraft.glow_squid_spawn_egg": "Oy Bewhe Stifek-Splanna",
  "item.minecraft.glowstone_dust": "Ponn Splannven",
  "item.minecraft.goat_horn": "Korn Gaver",
  "item.minecraft.goat_spawn_egg": "Oy Bewhe Gaver",
  "item.minecraft.gold_ingot": "Etewik Owr",
  "item.minecraft.gold_nugget": "Tamm Owr",
  "item.minecraft.golden_apple": "Aval Owr",
  "item.minecraft.golden_axe": "Bool Owr",
  "item.minecraft.golden_boots": "Botas Owr",
  "item.minecraft.golden_carrot": "Karetysen Owr",
  "item.minecraft.golden_chestplate": "Lurik Owr",
  "item.minecraft.golden_helmet": "Basnet Owr",
  "item.minecraft.golden_hoe": "Kravell Owr",
  "item.minecraft.golden_horse_armor": "Arvwisk Margh Owr",
  "item.minecraft.golden_leggings": "Lavrek Owr",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Pigell Owr",
  "item.minecraft.golden_shovel": "Pal Owr",
  "item.minecraft.golden_spear": "Guw Owrek",
  "item.minecraft.golden_sword": "Kledha Owr",
  "item.minecraft.gray_bundle": "Pusorn Loos",
  "item.minecraft.gray_dye": "Liw Loos",
  "item.minecraft.gray_harness": "Hernes Loos",
  "item.minecraft.green_bundle": "Pusorn Gwyrdh",
  "item.minecraft.green_dye": "Liw Gwyrdh",
  "item.minecraft.green_harness": "Hernes Gwyrdh",
  "item.minecraft.guardian_spawn_egg": "Oy Bewhe Gwithyas",
  "item.minecraft.gunpowder": "Ponn Gonn",
  "item.minecraft.guster_banner_pattern": "Patron Baner",
  "item.minecraft.guster_banner_pattern.desc": "Awel Glor",
  "item.minecraft.guster_banner_pattern.new": "Patron Baner Awel Glor",
  "item.minecraft.guster_pottery_sherd": "Darn Priweyth Awel Glor",
  "item.minecraft.happy_ghast_spawn_egg": "Oy Bewhe Tarosvan Lowen",
  "item.minecraft.harness": "Hernes",
  "item.minecraft.heart_of_the_sea": "Kolon an Mor",
  "item.minecraft.heart_pottery_shard": "Darn Pott Kolon",
  "item.minecraft.heart_pottery_sherd": "Darn Pott Kolon",
  "item.minecraft.heartbreak_pottery_shard": "Darn Pott Kolon Derrys",
  "item.minecraft.heartbreak_pottery_sherd": "Darn Pott Kolon Derrys",
  "item.minecraft.hoglin_spawn_egg": "Oy Bewhe Hoglin",
  "item.minecraft.honey_bottle": "Botel Mel",
  "item.minecraft.honeycomb": "Kriben vel",
  "item.minecraft.hopper_minecart": "Balgert gans Korn-Dinewi",
  "item.minecraft.horse_spawn_egg": "Oy Bewhe Margh",
  "item.minecraft.host_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.host_armor_trim_smithing_template.new": "Taklans Arvwisk Ost",
  "item.minecraft.howl_pottery_shard": "Darn Priweyth Oulya",
  "item.minecraft.howl_pottery_sherd": "Darn Priweyth Oulya",
  "item.minecraft.husk_spawn_egg": "Oy Bewhe Krogen Wag",
  "item.minecraft.ink_sac": "Sagh Ynk",
  "item.minecraft.iron_axe": "Bool Horn",
  "item.minecraft.iron_boots": "Botas Horn",
  "item.minecraft.iron_chestplate": "Lurik Horn",
  "item.minecraft.iron_golem_spawn_egg": "Oy Bewhe Golem Hornek",
  "item.minecraft.iron_helmet": "Basnet Horn",
  "item.minecraft.iron_hoe": "Kravell Horn",
  "item.minecraft.iron_horse_armor": "Arvwisk Margh Horn",
  "item.minecraft.iron_ingot": "Etewik Horn",
  "item.minecraft.iron_leggings": "Lavrek Horn",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Tamm Horn",
  "item.minecraft.iron_pickaxe": "Pigell Horn",
  "item.minecraft.iron_shovel": "Pal Horn",
  "item.minecraft.iron_spear": "Guw Horn",
  "item.minecraft.iron_sword": "Kledha Horn",
  "item.minecraft.item_frame": "Fram",
  "item.minecraft.jungle_boat": "Skath Wylgos",
  "item.minecraft.jungle_chest_boat": "Skath Wylgos gans Kist",
  "item.minecraft.knowledge_book": "Lyver Skians",
  "item.minecraft.lapis_lazuli": "Lapis",
  "item.minecraft.lava_bucket": "Kelorn Lava",
  "item.minecraft.lead": "Lesh",
  "item.minecraft.leather": "Ledher",
  "item.minecraft.leather_boots": "Botas Ledher",
  "item.minecraft.leather_chestplate": "Lurik Ledher",
  "item.minecraft.leather_helmet": "Kappa Ledher",
  "item.minecraft.leather_horse_armor": "Arvwisk Margh Ledher",
  "item.minecraft.leather_leggings": "Lavrek Ledher",
  "item.minecraft.light_blue_bundle": "Pusorn Glaswynn",
  "item.minecraft.light_blue_dye": "Liw Glaswynn",
  "item.minecraft.light_blue_harness": "Hernes Glaswynn",
  "item.minecraft.light_gray_bundle": "Pusorn Gwynnloos",
  "item.minecraft.light_gray_dye": "Liw Gwynnloos",
  "item.minecraft.light_gray_harness": "Hernes Gwynnloos",
  "item.minecraft.lime_bundle": "Pusorn Gwyrdhwynn",
  "item.minecraft.lime_dye": "Liw Gwynnwyrdh",
  "item.minecraft.lime_harness": "Hernes Gwynnwyrdh",
  "item.minecraft.lingering_potion": "Ismegen Dhidorr",
  "item.minecraft.lingering_potion.effect.awkward": "Ismegen Dhidorr Kledhek",
  "item.minecraft.lingering_potion.effect.empty": "Ismegen Dhidorr Ankreftyadow",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Ismegen Dhidorr Defens Tan",
  "item.minecraft.lingering_potion.effect.harming": "Diwas Didorr Shyndya",
  "item.minecraft.lingering_potion.effect.healing": "Ismegen Dhidorr Sawya",
  "item.minecraft.lingering_potion.effect.infested": "Ismegen Dhidorr an Pla",
  "item.minecraft.lingering_potion.effect.invisibility": "Ismegen Dhidorr Anweladewder",
  "item.minecraft.lingering_potion.effect.leaping": "Ismegen Dhidorr Lamma",
  "item.minecraft.lingering_potion.effect.levitation": "Ismegen Dhidorr Omsevelyans",
  "item.minecraft.lingering_potion.effect.luck": "Ismegen Dhidorr Chons",
  "item.minecraft.lingering_potion.effect.mundane": "Ismegen Gemmyn Didorr",
  "item.minecraft.lingering_potion.effect.night_vision": "Ismegen Dhidorr Gwel Nos",
  "item.minecraft.lingering_potion.effect.oozing": "Ismegen Dhidorr Sygera",
  "item.minecraft.lingering_potion.effect.poison": "Ismegen Dhidorr Gwenon",
  "item.minecraft.lingering_potion.effect.regeneration": "Ismegen Dhidorr Dastinythyans",
  "item.minecraft.lingering_potion.effect.slow_falling": "Ismegen Dhidorr Kodh Lent",
  "item.minecraft.lingering_potion.effect.slowness": "Ismegen Dhidorr Lenter",
  "item.minecraft.lingering_potion.effect.strength": "Diwas Didorr Krevder",
  "item.minecraft.lingering_potion.effect.swiftness": "Ismegen Dhidorr Skavder",
  "item.minecraft.lingering_potion.effect.thick": "Ismegen Dew Didorr",
  "item.minecraft.lingering_potion.effect.turtle_master": "Ismegen Dhidorr Arlodh an Morgroban",
  "item.minecraft.lingering_potion.effect.water": "Botel Dowr Didorr",
  "item.minecraft.lingering_potion.effect.water_breathing": "Ismegen Dhidorr Anella Dowr",
  "item.minecraft.lingering_potion.effect.weakness": "Ismegen Dhidorr Gwander",
  "item.minecraft.lingering_potion.effect.weaving": "Ismegen Dhidorr Gwia",
  "item.minecraft.lingering_potion.effect.wind_charged": "Ismegen Dhidorr Charj Awel",
  "item.minecraft.llama_spawn_egg": "Oy Bewhe Llama",
  "item.minecraft.lodestone_compass": "Mornaswydh Denven",
  "item.minecraft.mace": "Gwelen Allos",
  "item.minecraft.magenta_bundle": "Pusorn Majenta",
  "item.minecraft.magenta_dye": "Liw Majenta",
  "item.minecraft.magenta_harness": "Hernes Majenta",
  "item.minecraft.magma_cream": "Dehen Magma",
  "item.minecraft.magma_cube_spawn_egg": "Oy Bewhe Kub Lava",
  "item.minecraft.mangrove_boat": "Skath Vangrof",
  "item.minecraft.mangrove_chest_boat": "Skath Vangrof gans Kist",
  "item.minecraft.map": "Mappa Gwag",
  "item.minecraft.melon_seeds": "Has Pompyon Hweg",
  "item.minecraft.melon_slice": "Tregh Pompyon Hweg",
  "item.minecraft.milk_bucket": "Kelorn Leth",
  "item.minecraft.minecart": "Balgert",
  "item.minecraft.miner_pottery_shard": "Darn Pott Den Bal",
  "item.minecraft.miner_pottery_sherd": "Darn Pott Den Bal",
  "item.minecraft.mojang_banner_pattern": "Patron Baner",
  "item.minecraft.mojang_banner_pattern.desc": "Pyth",
  "item.minecraft.mojang_banner_pattern.new": "Patron Baner Tra",
  "item.minecraft.mooshroom_spawn_egg": "Oy Bewhe Skavel Gwarthek",
  "item.minecraft.mourner_pottery_shard": "Darn Pott Gwardyas",
  "item.minecraft.mourner_pottery_sherd": "Darn Pott Gwardyas",
  "item.minecraft.mule_spawn_egg": "Oy Bewhe Mul",
  "item.minecraft.mushroom_stew": "Kowl Skavell Gronek",
  "item.minecraft.music_disc_11": "Plasen Ilow",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Plasen Ilow",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Plasen Ilow",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Plasen Ilow",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Plasen Ilow",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Plasen Ilow",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Plasen Ilow",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Plasen Ilow",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Kist Ilowek)",
  "item.minecraft.music_disc_far": "Plasen Ilow",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Plasen Ilow",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Plasen Ilow",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Plasen Ilow",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Plasen Ilow",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Plasen Ilow",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Plasen Ilow",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Plasen Ilow",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Plasen Ilow",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Plasen Ilow",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Plasen Ilow",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Plasen Ilow",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Plasen Ilow",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Kig Mols Kriv",
  "item.minecraft.name_tag": "Tagg Hanow",
  "item.minecraft.nautilus_shell": "Krogen Nautilus",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Bryckys Nether",
  "item.minecraft.nether_star": "Steren Nether",
  "item.minecraft.nether_wart": "Losowen an Yfarn",
  "item.minecraft.netherite_axe": "Bool Netherit",
  "item.minecraft.netherite_boots": "Botas Netherit",
  "item.minecraft.netherite_chestplate": "Lurik Netherit",
  "item.minecraft.netherite_helmet": "Basnet Netherit",
  "item.minecraft.netherite_hoe": "Kravell Netherit",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Etewik Netherit",
  "item.minecraft.netherite_leggings": "Lavrek Netherit",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Pigell Netherit",
  "item.minecraft.netherite_scrap": "Tamm Netherit",
  "item.minecraft.netherite_shovel": "Pal Netherit",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Kledha Netherit",
  "item.minecraft.netherite_upgrade_smithing_template": "Skantlyn Gov",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Ughradh Netherit",
  "item.minecraft.oak_boat": "Skath Dhar",
  "item.minecraft.oak_chest_boat": "Skath Dhar gans Kist",
  "item.minecraft.ocelot_spawn_egg": "Oy Bewhe Kath Wyls",
  "item.minecraft.ominous_bottle": "Botel Kolyek",
  "item.minecraft.ominous_trial_key": "Alhwedh Prov Kolyek",
  "item.minecraft.orange_bundle": "Pusorn Rudhvelyn",
  "item.minecraft.orange_dye": "Liw Rudhvelyn",
  "item.minecraft.orange_harness": "Hernes Rudhvelyn",
  "item.minecraft.painting": "Lymnans",
  "item.minecraft.pale_oak_boat": "Skath Dhar Disliw",
  "item.minecraft.pale_oak_chest_boat": "Skath Dhar Disliw gans Kist",
  "item.minecraft.panda_spawn_egg": "Oy Bewhe Panda",
  "item.minecraft.paper": "Paper",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Oy Bewhe Papynjay",
  "item.minecraft.phantom_membrane": "Kennen Fantom",
  "item.minecraft.phantom_spawn_egg": "Oy Bewhe Fantom",
  "item.minecraft.pig_spawn_egg": "Oy Bewhe Hogh",
  "item.minecraft.piglin_banner_pattern": "Patron Baner",
  "item.minecraft.piglin_banner_pattern.desc": "Tron",
  "item.minecraft.piglin_banner_pattern.new": "Patron Baner Tron",
  "item.minecraft.piglin_brute_spawn_egg": "Oy Bewhe Bilen Piglin",
  "item.minecraft.piglin_spawn_egg": "Oy Bewhe Piglin",
  "item.minecraft.pillager_spawn_egg": "Oy Bewhe Preydhesik",
  "item.minecraft.pink_bundle": "Pusorn Rudhwynn",
  "item.minecraft.pink_dye": "Liw Rudhwynn",
  "item.minecraft.pink_harness": "Hernes Rudhwynn",
  "item.minecraft.pitcher_plant": "Les Pycher",
  "item.minecraft.pitcher_pod": "Kodh Pycher",
  "item.minecraft.plenty_pottery_shard": "Darn Pott Kist",
  "item.minecraft.plenty_pottery_sherd": "Darn Pott Kist",
  "item.minecraft.poisonous_potato": "Aval Dor Gwenonek",
  "item.minecraft.polar_bear_spawn_egg": "Oy Bewhe Ors Gwynn",
  "item.minecraft.popped_chorus_fruit": "Frothen Goros Poppys",
  "item.minecraft.porkchop": "Kig Mogh Kriv",
  "item.minecraft.potato": "Aval Dor",
  "item.minecraft.potion": "Ismegen",
  "item.minecraft.potion.effect.awkward": "Ismegen Gledhek",
  "item.minecraft.potion.effect.empty": "Ismegen Ankreftyadow",
  "item.minecraft.potion.effect.fire_resistance": "Ismegen Dhefens Tan",
  "item.minecraft.potion.effect.harming": "Ismegen Shyndya",
  "item.minecraft.potion.effect.healing": "Ismegen Sawya",
  "item.minecraft.potion.effect.infested": "Ismegen an Pla",
  "item.minecraft.potion.effect.invisibility": "Ismegen Anweladewder",
  "item.minecraft.potion.effect.leaping": "Ismegen Lamma",
  "item.minecraft.potion.effect.levitation": "Ismegen Omsevelyans",
  "item.minecraft.potion.effect.luck": "Ismegen Jons",
  "item.minecraft.potion.effect.mundane": "Ismegen Gemmyn",
  "item.minecraft.potion.effect.night_vision": "Ismegen Wel Nos",
  "item.minecraft.potion.effect.oozing": "Ismegen Syger",
  "item.minecraft.potion.effect.poison": "Ismegen Wenon",
  "item.minecraft.potion.effect.regeneration": "Ismegen Dhastinytheans",
  "item.minecraft.potion.effect.slow_falling": "Ismegen Godh Lent",
  "item.minecraft.potion.effect.slowness": "Ismegen Lenter",
  "item.minecraft.potion.effect.strength": "Ismegen Grevder",
  "item.minecraft.potion.effect.swiftness": "Ismegen Skavder",
  "item.minecraft.potion.effect.thick": "Ismegen Dew",
  "item.minecraft.potion.effect.turtle_master": "Ismegen Arlodh an Morgroban",
  "item.minecraft.potion.effect.water": "Botel Dowr",
  "item.minecraft.potion.effect.water_breathing": "Ismegen Anella Dowr",
  "item.minecraft.potion.effect.weakness": "Ismegen Wander",
  "item.minecraft.potion.effect.weaving": "Ismegen Wia",
  "item.minecraft.potion.effect.wind_charged": "Ismegen Jarj Awel",
  "item.minecraft.pottery_shard_archer": "Darn Pott Sether",
  "item.minecraft.pottery_shard_arms_up": "Darn Pott Diwvregh Yn-Bann",
  "item.minecraft.pottery_shard_prize": "Darn Pott Pewas",
  "item.minecraft.pottery_shard_skull": "Darn Pott Klopen",
  "item.minecraft.powder_snow_bucket": "Kelorn Ergh Poltrus",
  "item.minecraft.prismarine_crystals": "Gwrysow Prismarin",
  "item.minecraft.prismarine_shard": "Tamm Prismarin",
  "item.minecraft.prize_pottery_shard": "Darn Pott Pewas",
  "item.minecraft.prize_pottery_sherd": "Darn Pott Pewas",
  "item.minecraft.pufferfish": "Hwythpysk",
  "item.minecraft.pufferfish_bucket": "Kelorn Hwythpysk",
  "item.minecraft.pufferfish_spawn_egg": "Oy Bewhe Hwythpysk",
  "item.minecraft.pumpkin_pie": "Hogen Bompyon",
  "item.minecraft.pumpkin_seeds": "Has Pompyon",
  "item.minecraft.purple_bundle": "Pusorn Purpur",
  "item.minecraft.purple_dye": "Liw Purpur",
  "item.minecraft.purple_harness": "Hernes Purpur",
  "item.minecraft.quartz": "Kanndir Nether",
  "item.minecraft.rabbit": "Kig Konin Kriv",
  "item.minecraft.rabbit_foot": "Troos Konin",
  "item.minecraft.rabbit_hide": "Kroghen Gonin",
  "item.minecraft.rabbit_spawn_egg": "Oy Bewhe Konin",
  "item.minecraft.rabbit_stew": "Kowl Gonin",
  "item.minecraft.raiser_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Taklans Arvwisk Drehevyer",
  "item.minecraft.ravager_spawn_egg": "Oy Bewhe Defolyer",
  "item.minecraft.raw_copper": "Kober Kriv",
  "item.minecraft.raw_gold": "Owr Kriv",
  "item.minecraft.raw_iron": "Horn Kriv",
  "item.minecraft.recovery_compass": "Mornaswydh Daskavos",
  "item.minecraft.red_bundle": "Pusorn Rudh",
  "item.minecraft.red_dye": "Liw Rudh",
  "item.minecraft.red_harness": "Hernes Rudh",
  "item.minecraft.redstone": "Ponn Rudhven",
  "item.minecraft.resin_brick": "Bryck Rosin",
  "item.minecraft.resin_clump": "Rann Rosin",
  "item.minecraft.rib_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Taklans Arvwisk Asowen",
  "item.minecraft.rotten_flesh": "Kig Poder",
  "item.minecraft.saddle": "Diber",
  "item.minecraft.salmon": "Eghek Kriv",
  "item.minecraft.salmon_bucket": "Kelorn Eghek",
  "item.minecraft.salmon_spawn_egg": "Oy Bewhe Eghek",
  "item.minecraft.scrape_pottery_sherd": "Darn Pott Bool",
  "item.minecraft.scute": "Skansen",
  "item.minecraft.sentry_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Taklans Arvwisk Golyer",
  "item.minecraft.shaper_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Taklans Arvwisk Shapyer",
  "item.minecraft.sheaf_pottery_shard": "Darn Pott Gwaneth",
  "item.minecraft.sheaf_pottery_sherd": "Darn Pott Gwaneth",
  "item.minecraft.shears": "Gwelsow",
  "item.minecraft.sheep_spawn_egg": "Oy Bewhe Davas",
  "item.minecraft.shelter_pottery_shard": "Darn Pott Gwedhen",
  "item.minecraft.shelter_pottery_sherd": "Darn Pott Gwedhen",
  "item.minecraft.shield": "Skoos",
  "item.minecraft.shield.black": "Skoos Du",
  "item.minecraft.shield.blue": "Skoos Glas",
  "item.minecraft.shield.brown": "Skoos Gell",
  "item.minecraft.shield.cyan": "Skoos Glaswyrdh",
  "item.minecraft.shield.gray": "Skoos Loos",
  "item.minecraft.shield.green": "Skoos Gwyrdh",
  "item.minecraft.shield.light_blue": "Skoos Glaswynn",
  "item.minecraft.shield.light_gray": "Skoos Loos Golow",
  "item.minecraft.shield.lime": "Skoos Gwynnwyrdh",
  "item.minecraft.shield.magenta": "Skoos Majenta",
  "item.minecraft.shield.orange": "Skoos Rudhvelyn",
  "item.minecraft.shield.pink": "Skoos Rudhwynn",
  "item.minecraft.shield.purple": "Skoos Purpur",
  "item.minecraft.shield.red": "Skoos Rudh",
  "item.minecraft.shield.white": "Skoos Gwynn",
  "item.minecraft.shield.yellow": "Skoos Melyn",
  "item.minecraft.shulker_shell": "Krogen Shulker",
  "item.minecraft.shulker_spawn_egg": "Oy Bewhe Shulker",
  "item.minecraft.sign": "Arwodh",
  "item.minecraft.silence_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Taklans Arvwisk Taw",
  "item.minecraft.silverfish_spawn_egg": "Oy Bewhe Pysk Arghans",
  "item.minecraft.skeleton_horse_spawn_egg": "Oy Bewhe Margh Eskern",
  "item.minecraft.skeleton_spawn_egg": "Oy Bewhe Korf Eskern",
  "item.minecraft.skull_banner_pattern": "Patron Baner",
  "item.minecraft.skull_banner_pattern.desc": "Arwodh Klopen",
  "item.minecraft.skull_banner_pattern.new": "Patron Baner Arwodh Klopen",
  "item.minecraft.skull_pottery_shard": "Darn Pott Klopen",
  "item.minecraft.skull_pottery_sherd": "Darn Pott Klopen",
  "item.minecraft.slime_ball": "Slimbel",
  "item.minecraft.slime_spawn_egg": "Oy Bewhe Slim",
  "item.minecraft.smithing_template": "Skantlyn Gov",
  "item.minecraft.smithing_template.applies_to": "Usys rag:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Keworra etewik po gwrys",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Arvwisk",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Keworra darn arvwisk",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Etewigow & Gwrysow",
  "item.minecraft.smithing_template.ingredients": "Devnydhyow:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Keworra Etewik Netherit",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Daffar Adamant",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Add diamond armor, weapon, or tool",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Etewik Netherit",
  "item.minecraft.smithing_template.upgrade": "Ughgradha: ",
  "item.minecraft.sniffer_spawn_egg": "Oy Bewhe Frikhwyther",
  "item.minecraft.snort_pottery_shard": "Darn Pott Frikhwyth",
  "item.minecraft.snort_pottery_sherd": "Darn Pott Frikhwyth",
  "item.minecraft.snout_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Taklans Arvwisk Tron",
  "item.minecraft.snow_golem_spawn_egg": "Oy Bewhe Golem Erghek",
  "item.minecraft.snowball": "Pel Ergh",
  "item.minecraft.spectral_arrow": "Seth Tarosvannus",
  "item.minecraft.spider_eye": "Lagas Kevnisen",
  "item.minecraft.spider_spawn_egg": "Oy Bewhe Kevnisen",
  "item.minecraft.spire_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Taklans Arvwisk Mondour",
  "item.minecraft.splash_potion": "Ismegen Lagyek",
  "item.minecraft.splash_potion.effect.awkward": "Ismegen Lagyek Kledhek",
  "item.minecraft.splash_potion.effect.empty": "Ismegen Lagyek Ankreftyadow",
  "item.minecraft.splash_potion.effect.fire_resistance": "Ismegen Lagyek Defens Tan",
  "item.minecraft.splash_potion.effect.harming": "Ismegen Lagyek Shyndya",
  "item.minecraft.splash_potion.effect.healing": "Ismegen Lagyek Sawya",
  "item.minecraft.splash_potion.effect.infested": "Ismegen Lagyek an Pla",
  "item.minecraft.splash_potion.effect.invisibility": "Ismegen Lagyek Anweladewder",
  "item.minecraft.splash_potion.effect.leaping": "Ismegen Lagyek Lamma",
  "item.minecraft.splash_potion.effect.levitation": "Ismegen Lagyek Omsevelyans",
  "item.minecraft.splash_potion.effect.luck": "Ismegen Lagyek Chons",
  "item.minecraft.splash_potion.effect.mundane": "Ismegen Lagyek Kemmyn",
  "item.minecraft.splash_potion.effect.night_vision": "Ismegen Lagyek Gwel Nos",
  "item.minecraft.splash_potion.effect.oozing": "Ismegen Lagyek Syger",
  "item.minecraft.splash_potion.effect.poison": "Ismegen Lagyek Gwenon",
  "item.minecraft.splash_potion.effect.regeneration": "Ismegen Lagyek Dastinytheans",
  "item.minecraft.splash_potion.effect.slow_falling": "Ismegen Lagyek Kodh Lent",
  "item.minecraft.splash_potion.effect.slowness": "Ismegen Lagyek Lenter",
  "item.minecraft.splash_potion.effect.strength": "Ismegen Lagyek Krevder",
  "item.minecraft.splash_potion.effect.swiftness": "Ismegen Lagyek Skavder",
  "item.minecraft.splash_potion.effect.thick": "Ismegen Dew Lagyek",
  "item.minecraft.splash_potion.effect.turtle_master": "Ismegen Lagyek Arlodh an Morgroban",
  "item.minecraft.splash_potion.effect.water": "Botel Dowr Lagyek",
  "item.minecraft.splash_potion.effect.water_breathing": "Ismegen Lagyek Anella Dowr",
  "item.minecraft.splash_potion.effect.weakness": "Ismegen Lagyek Gwander",
  "item.minecraft.splash_potion.effect.weaving": "Ismegen Lagyek Gwia",
  "item.minecraft.splash_potion.effect.wind_charged": "Ismegen Lagyek Charj Awel",
  "item.minecraft.spruce_boat": "Skath Sprus",
  "item.minecraft.spruce_chest_boat": "Skath Sprus gans Kist",
  "item.minecraft.spyglass": "Gweder Aspia",
  "item.minecraft.squid_spawn_egg": "Oy Bewhe Stifek",
  "item.minecraft.stick": "Gwelen",
  "item.minecraft.stone_axe": "Bool Ven",
  "item.minecraft.stone_hoe": "Kravell Ven",
  "item.minecraft.stone_pickaxe": "Pigell Ven",
  "item.minecraft.stone_shovel": "Pal Ven",
  "item.minecraft.stone_spear": "Guw Men",
  "item.minecraft.stone_sword": "Kledha Men",
  "item.minecraft.stray_spawn_egg": "Oy Bewhe Kellys",
  "item.minecraft.strider_spawn_egg": "Oy Bewhe Hirgammer",
  "item.minecraft.string": "Korden",
  "item.minecraft.sugar": "Sugra",
  "item.minecraft.suspicious_stew": "Kowl Skeusek",
  "item.minecraft.sweet_berries": "Moren Hweg",
  "item.minecraft.tadpole_bucket": "Kelorn Penynnow",
  "item.minecraft.tadpole_spawn_egg": "Oy Bewhe Pennyn",
  "item.minecraft.tide_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Taklans Arvwisk Morlanwes",
  "item.minecraft.tipped_arrow": "Seth gans Bleyn",
  "item.minecraft.tipped_arrow.effect.awkward": "Seth gans Bleyn",
  "item.minecraft.tipped_arrow.effect.empty": "Seth gans Bleyn Ankreftyadow",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Seth Dhefens Tan",
  "item.minecraft.tipped_arrow.effect.harming": "Seth Shyndya",
  "item.minecraft.tipped_arrow.effect.healing": "Seth Sawya",
  "item.minecraft.tipped_arrow.effect.infested": "Seth an Bla",
  "item.minecraft.tipped_arrow.effect.invisibility": "Seth Anweladewder",
  "item.minecraft.tipped_arrow.effect.leaping": "Seth Lamma",
  "item.minecraft.tipped_arrow.effect.levitation": "Seth Omsevelyans",
  "item.minecraft.tipped_arrow.effect.luck": "Seth Chons",
  "item.minecraft.tipped_arrow.effect.mundane": "Seth gans Bleyn",
  "item.minecraft.tipped_arrow.effect.night_vision": "Seth Wel Nos",
  "item.minecraft.tipped_arrow.effect.oozing": "Seth Syger",
  "item.minecraft.tipped_arrow.effect.poison": "Seth Wenon",
  "item.minecraft.tipped_arrow.effect.regeneration": "Seth Dhastinytheans",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Seth Kodh Lent",
  "item.minecraft.tipped_arrow.effect.slowness": "Seth Lenter",
  "item.minecraft.tipped_arrow.effect.strength": "Seth Krevder",
  "item.minecraft.tipped_arrow.effect.swiftness": "Seth Skavder",
  "item.minecraft.tipped_arrow.effect.thick": "Seth gans Bleyn",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Seth Arlodh an Morgroban",
  "item.minecraft.tipped_arrow.effect.water": "Seth Lagya",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Seth Anella Dowr",
  "item.minecraft.tipped_arrow.effect.weakness": "Seth Wander",
  "item.minecraft.tipped_arrow.effect.weaving": "Seth Wia",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Seth Jarj Awel",
  "item.minecraft.tnt_minecart": "Balgert gans Dynamit",
  "item.minecraft.torchflower_seeds": "Has Tanvleujen",
  "item.minecraft.totem_of_undying": "Ikon Dasserghyans",
  "item.minecraft.trader_llama_spawn_egg": "Oy Bewhe Llama Gwikor",
  "item.minecraft.trial_key": "Alhwedh Prov",
  "item.minecraft.trident": "Tryforgh",
  "item.minecraft.tropical_fish": "Pysk Trovannel",
  "item.minecraft.tropical_fish_bucket": "Kelorn Pysk Trovannel",
  "item.minecraft.tropical_fish_spawn_egg": "Oy Bewhe Pysk Trovannel",
  "item.minecraft.turtle_helmet": "Krogen Vorgroban",
  "item.minecraft.turtle_scute": "Skansen Morgroban",
  "item.minecraft.turtle_spawn_egg": "Oy Bewhe Morgroban",
  "item.minecraft.vex_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Taklans Arvwisk Molleth",
  "item.minecraft.vex_spawn_egg": "Oy Bewhe Molleth",
  "item.minecraft.villager_spawn_egg": "Oy Bewhe Trevesik",
  "item.minecraft.vindicator_spawn_egg": "Oy Bewhe Venjyanser",
  "item.minecraft.wandering_trader_spawn_egg": "Oy Bewhe Gwikor Gwandrek",
  "item.minecraft.ward_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Taklans Arvwisk Gward",
  "item.minecraft.warden_spawn_egg": "Oy Bewhe Gwardyas",
  "item.minecraft.warped_fungus_on_a_stick": "Fong Koynt war Welen",
  "item.minecraft.water_bucket": "Kelorn Dowr",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Taklans Arvwisk Tremenyas",
  "item.minecraft.wheat": "Gwaneth",
  "item.minecraft.wheat_seeds": "Has Gwaneth",
  "item.minecraft.white_bundle": "Pusorn Gwynn",
  "item.minecraft.white_dye": "Liw Gwynn",
  "item.minecraft.white_harness": "Hernes Gwynn",
  "item.minecraft.wild_armor_trim_smithing_template": "Skantlyn Gov",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Taklans Arvwisk Gwyls",
  "item.minecraft.wind_charge": "Charj Awel",
  "item.minecraft.witch_spawn_egg": "Oy Bewhe Gwragh",
  "item.minecraft.wither_skeleton_spawn_egg": "Oy Bewhe Korf Eskern Gwedhrek",
  "item.minecraft.wither_spawn_egg": "Oy Bewhe Gwedhrer",
  "item.minecraft.wolf_armor": "Arvwisk Bleydh",
  "item.minecraft.wolf_spawn_egg": "Oy Bewhe Bleydh",
  "item.minecraft.wooden_axe": "Bool Brenn",
  "item.minecraft.wooden_hoe": "Kravell Brenn",
  "item.minecraft.wooden_pickaxe": "Pigell Brenn",
  "item.minecraft.wooden_shovel": "Pal Brenn",
  "item.minecraft.wooden_spear": "Guw Prennek",
  "item.minecraft.wooden_sword": "Kledha Prenn",
  "item.minecraft.writable_book": "Lyver ha Pluven",
  "item.minecraft.written_book": "Lyver Skrifys",
  "item.minecraft.yellow_bundle": "Pusorn Melyn",
  "item.minecraft.yellow_dye": "Liw Melyn",
  "item.minecraft.yellow_harness": "Hernes Melyn",
  "item.minecraft.zoglin_spawn_egg": "Oy Bewhe Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Oy Bewhe Margh Zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Oy Bewhe Zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Oy Bewhe Trevesik Zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Oy Bewhe Piglin Zombi"
}
export const kw_gb = items; 
